import { emptyBaseSplitApi as api } from './baseApi';
import Tag from './tag';
const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    getApiApiDocsJson: build.query<GetApiApiDocsJsonApiResponse, GetApiApiDocsJsonApiArg>({
      query: () => ({ url: `/api/api-docs.json` }),
    }),
    authChangePasswordCreate: build.mutation<AuthChangePasswordCreateApiResponse, AuthChangePasswordCreateApiArg>({
      query: queryArg => ({ url: `/api/auth/change-password/`, method: 'POST', body: queryArg.body }),
    }),
    authConfirmEmailCreate: build.mutation<AuthConfirmEmailCreateApiResponse, AuthConfirmEmailCreateApiArg>({
      query: queryArg => ({ url: `/api/auth/confirm-email/`, method: 'POST', body: queryArg.body }),
    }),
    authForgotPasswordCreate: build.mutation<AuthForgotPasswordCreateApiResponse, AuthForgotPasswordCreateApiArg>({
      query: queryArg => ({ url: `/api/auth/forgot-password/`, method: 'POST', body: queryArg.body }),
    }),
    authIsVerifiedRetrieve: build.query<AuthIsVerifiedRetrieveApiResponse, AuthIsVerifiedRetrieveApiArg>({
      query: () => ({ url: `/api/auth/is-verified/` }),
    }),
    authLoginCreate: build.mutation<AuthLoginCreateApiResponse, AuthLoginCreateApiArg>({
      query: queryArg => ({ url: `/api/auth/login/`, method: 'POST', body: queryArg.body }),
    }),
    authRefreshCreate: build.mutation<AuthRefreshCreateApiResponse, AuthRefreshCreateApiArg>({
      query: queryArg => ({ url: `/api/auth/refresh/`, method: 'POST', body: queryArg.tokenRefreshRequest }),
    }),
    authRegisterCreate: build.mutation<AuthRegisterCreateApiResponse, AuthRegisterCreateApiArg>({
      query: queryArg => ({ url: `/api/auth/register/`, method: 'POST', body: queryArg.userRegistrationRequest }),
    }),
    authResendCodeCreate: build.mutation<AuthResendCodeCreateApiResponse, AuthResendCodeCreateApiArg>({
      query: queryArg => ({ url: `/api/auth/resend-code/`, method: 'POST', body: queryArg.body }),
    }),
    authResetPasswordCreate: build.mutation<AuthResetPasswordCreateApiResponse, AuthResetPasswordCreateApiArg>({
      query: queryArg => ({ url: `/api/auth/reset-password/`, method: 'POST', body: queryArg.body }),
    }),
    authVerifyEmailRetrieve: build.query<AuthVerifyEmailRetrieveApiResponse, AuthVerifyEmailRetrieveApiArg>({
      query: queryArg => ({ url: `/api/auth/verify-email/`, params: { token: queryArg.token } }),
    }),
    billingAddTokensCreate: build.mutation<BillingAddTokensCreateApiResponse, BillingAddTokensCreateApiArg>({
      query: queryArg => ({ url: `/api/billing/add-tokens/`, method: 'POST', body: queryArg.addTokensRequestRequest }),
    }),
    billingAddTokensCreate2: build.mutation<BillingAddTokensCreate2ApiResponse, BillingAddTokensCreate2ApiArg>({
      query: () => ({ url: `/api/billing/add_tokens/`, method: 'POST' }),
    }),
    billingBalanceRetrieve: build.query<BillingBalanceRetrieveApiResponse, BillingBalanceRetrieveApiArg>({
      query: () => ({ url: `/api/billing/balance/` }),
    }),
    billingCheckoutCreate: build.mutation<BillingCheckoutCreateApiResponse, BillingCheckoutCreateApiArg>({
      query: queryArg => ({ url: `/api/billing/checkout/`, method: 'POST', body: queryArg.checkoutRequestRequest }),
    }),
    billingDebouncePricingRetrieve: build.query<
      BillingDebouncePricingRetrieveApiResponse,
      BillingDebouncePricingRetrieveApiArg
    >({
      query: () => ({ url: `/api/billing/debounce-pricing/` }),
    }),
    billingPlansRetrieve: build.query<BillingPlansRetrieveApiResponse, BillingPlansRetrieveApiArg>({
      query: () => ({ url: `/api/billing/plans/` }),
    }),
    billingSubscriptionCancelCreate: build.mutation<
      BillingSubscriptionCancelCreateApiResponse,
      BillingSubscriptionCancelCreateApiArg
    >({
      query: () => ({ url: `/api/billing/subscription/cancel/`, method: 'POST' }),
    }),
    billingTokenCostsRetrieve: build.query<BillingTokenCostsRetrieveApiResponse, BillingTokenCostsRetrieveApiArg>({
      query: () => ({ url: `/api/billing/token-costs/` }),
    }),
    billingTransactionsRetrieve: build.query<BillingTransactionsRetrieveApiResponse, BillingTransactionsRetrieveApiArg>(
      {
        query: () => ({ url: `/api/billing/transactions/` }),
      },
    ),
    billingVerifyEmailsCreate: build.mutation<BillingVerifyEmailsCreateApiResponse, BillingVerifyEmailsCreateApiArg>({
      query: queryArg => ({
        url: `/api/billing/verify-emails/`,
        method: 'POST',
        body: queryArg.verifyEmailsRequestRequest,
      }),
    }),
    billingWebhookStripeCreate: build.mutation<BillingWebhookStripeCreateApiResponse, BillingWebhookStripeCreateApiArg>(
      {
        query: () => ({ url: `/api/billing/webhook/stripe/`, method: 'POST' }),
      },
    ),
    campaignFiltersRetrieve: build.query<CampaignFiltersRetrieveApiResponse, CampaignFiltersRetrieveApiArg>({
      query: queryArg => ({ url: `/api/campaign-filters/${queryArg.campaignTypeId}/` }),
    }),
    campaignSourcesRetrieve: build.query<CampaignSourcesRetrieveApiResponse, CampaignSourcesRetrieveApiArg>({
      query: queryArg => ({ url: `/api/campaign-sources/${queryArg.campaignTypeId}/` }),
    }),
    campaignTypesRetrieve: build.query<CampaignTypesRetrieveApiResponse, CampaignTypesRetrieveApiArg>({
      query: () => ({ url: `/api/campaign-types/` }),
    }),
    campaignTypesProperRetrieve: build.query<CampaignTypesProperRetrieveApiResponse, CampaignTypesProperRetrieveApiArg>(
      {
        query: () => ({ url: `/api/campaign-types-proper/` }),
      },
    ),
    campaignsList: build.query<CampaignsListApiResponse, CampaignsListApiArg>({
      query: queryArg => ({
        url: `/api/campaigns/`,
        params: queryArg,
      }),
    }),
    campaignsCreate: build.mutation<CampaignsCreateApiResponse, CampaignsCreateApiArg>({
      query: queryArg => ({ url: `/api/campaigns/`, method: 'POST', body: queryArg.campaignRequest }),
    }),
    campaignsRetrieve: build.query<CampaignsRetrieveApiResponse, CampaignsRetrieveApiArg>({
      query: queryArg => ({ url: `/api/campaigns/${queryArg.id}/` }),
    }),
    campaignsUpdate: build.mutation<CampaignsUpdateApiResponse, CampaignsUpdateApiArg>({
      query: queryArg => ({ url: `/api/campaigns/${queryArg.id}/`, method: 'PUT', body: queryArg.campaignRequest }),
    }),
    campaignsPartialUpdate: build.mutation<CampaignsPartialUpdateApiResponse, CampaignsPartialUpdateApiArg>({
      query: queryArg => ({
        url: `/api/campaigns/${queryArg.id}/`,
        method: 'PATCH',
        body: queryArg.patchedCampaignRequest,
      }),
    }),
    campaignsDestroy: build.mutation<CampaignsDestroyApiResponse, CampaignsDestroyApiArg>({
      query: queryArg => ({ url: `/api/campaigns/${queryArg.id}/`, method: 'DELETE' }),
    }),
    campaignsFlowConfigCreate: build.mutation<CampaignsFlowConfigCreateApiResponse, CampaignsFlowConfigCreateApiArg>({
      query: queryArg => ({
        url: `/api/campaigns/${queryArg.id}/flow_config/`,
        method: 'POST',
        body: queryArg.flowConfigRequest,
      }),
    }),
    campaignsLeadsRetrieve: build.query<CampaignsLeadsRetrieveApiResponse, CampaignsLeadsRetrieveApiArg>({
      query: queryArg => ({ url: `/api/campaigns/${queryArg.id}/leads/` }),
    }),
    campaignsLinkEmailCreate: build.mutation<CampaignsLinkEmailCreateApiResponse, CampaignsLinkEmailCreateApiArg>({
      query: queryArg => ({
        url: `/api/campaigns/${queryArg.id}/link_email/`,
        method: 'POST',
        body: queryArg.emailLinkRequest,
      }),
    }),
    campaignsPublishLeadsCreate: build.mutation<
      CampaignsPublishLeadsCreateApiResponse,
      CampaignsPublishLeadsCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/campaigns/${queryArg.id}/publish_leads/`,
        method: 'POST',
        body: queryArg.campaignRequest,
      }),
    }),
    campaignsStartCreate: build.mutation<CampaignsStartCreateApiResponse, CampaignsStartCreateApiArg>({
      query: queryArg => ({
        url: `/api/campaigns/${queryArg.id}/start/`,
        method: 'POST',
        body: queryArg.campaignRequest,
      }),
    }),
    campaignsStatusRetrieve: build.query<CampaignsStatusRetrieveApiResponse, CampaignsStatusRetrieveApiArg>({
      query: queryArg => ({ url: `/api/campaigns/${queryArg.id}/status/` }),
    }),
    campaignsStopCreate: build.mutation<CampaignsStopCreateApiResponse, CampaignsStopCreateApiArg>({
      query: queryArg => ({
        url: `/api/campaigns/${queryArg.id}/stop/`,
        method: 'POST',
        body: queryArg.campaignRequest,
      }),
    }),
    campaignsTypesRetrieve: build.query<CampaignsTypesRetrieveApiResponse, CampaignsTypesRetrieveApiArg>({
      query: () => ({ url: `/api/campaigns/types/` }),
    }),
    emailCampaignsAccountsList: build.query<EmailCampaignsAccountsListApiResponse, EmailCampaignsAccountsListApiArg>({
      query: () => ({ url: `/api/email-campaigns/accounts/` }),
    }),
    emailCampaignsAccountsCreate: build.mutation<
      EmailCampaignsAccountsCreateApiResponse,
      EmailCampaignsAccountsCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/accounts/`,
        method: 'POST',
        body: queryArg.emailAccountCreateRequestRequest,
      }),
    }),
    emailCampaignsAccountsRetrieve: build.query<
      EmailCampaignsAccountsRetrieveApiResponse,
      EmailCampaignsAccountsRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/accounts/${queryArg.accountId}/` }),
    }),
    emailCampaignsAccountsUpdate: build.mutation<
      EmailCampaignsAccountsUpdateApiResponse,
      EmailCampaignsAccountsUpdateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/accounts/${queryArg.accountId}/`,
        method: 'PUT',
        body: queryArg.emailAccountCreateRequestRequest,
      }),
    }),
    emailCampaignsAccountsDestroy: build.mutation<
      EmailCampaignsAccountsDestroyApiResponse,
      EmailCampaignsAccountsDestroyApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/accounts/${queryArg.accountId}/`, method: 'DELETE' }),
    }),
    emailCampaignsAccountsPauseWarmupCreate: build.mutation<
      EmailCampaignsAccountsPauseWarmupCreateApiResponse,
      EmailCampaignsAccountsPauseWarmupCreateApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/accounts/${queryArg.accountId}/pause_warmup/`, method: 'POST' }),
    }),
    emailCampaignsAccountsStartWarmupCreate: build.mutation<
      EmailCampaignsAccountsStartWarmupCreateApiResponse,
      EmailCampaignsAccountsStartWarmupCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/accounts/${queryArg.accountId}/start_warmup/`,
        method: 'POST',
        body: queryArg.startWarmupRequestRequest,
      }),
    }),
    emailCampaignsAccountsTestCreate: build.mutation<
      EmailCampaignsAccountsTestCreateApiResponse,
      EmailCampaignsAccountsTestCreateApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/accounts/${queryArg.accountId}/test/`, method: 'POST' }),
    }),
    emailCampaignsAccountsWarmupStatusRetrieve: build.query<
      EmailCampaignsAccountsWarmupStatusRetrieveApiResponse,
      EmailCampaignsAccountsWarmupStatusRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/accounts/${queryArg.accountId}/warmup_status/` }),
    }),
    emailCampaignsAccountsImapSmtpCreate: build.mutation<
      EmailCampaignsAccountsImapSmtpCreateApiResponse,
      EmailCampaignsAccountsImapSmtpCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/accounts/imap-smtp/`,
        method: 'POST',
        body: queryArg.emailAccountCreateRequestRequest,
      }),
    }),
    emailCampaignsAccountsOauthGmailCallbackCreate: build.mutation<
      EmailCampaignsAccountsOauthGmailCallbackCreateApiResponse,
      EmailCampaignsAccountsOauthGmailCallbackCreateApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/accounts/oauth/gmail/callback/`, method: 'POST' }),
    }),
    emailCampaignsAccountsOauthGmailInitCreate: build.mutation<
      EmailCampaignsAccountsOauthGmailInitCreateApiResponse,
      EmailCampaignsAccountsOauthGmailInitCreateApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/accounts/oauth/gmail/init/`, method: 'POST' }),
    }),
    emailCampaignsAccountsOauthOutlookCallbackCreate: build.mutation<
      EmailCampaignsAccountsOauthOutlookCallbackCreateApiResponse,
      EmailCampaignsAccountsOauthOutlookCallbackCreateApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/accounts/oauth/outlook/callback/`, method: 'POST' }),
    }),
    emailCampaignsAccountsOauthOutlookInitCreate: build.mutation<
      EmailCampaignsAccountsOauthOutlookInitCreateApiResponse,
      EmailCampaignsAccountsOauthOutlookInitCreateApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/accounts/oauth/outlook/init/`, method: 'POST' }),
    }),
    emailCampaignsAdminEngagedLeadsList: build.query<
      EmailCampaignsAdminEngagedLeadsListApiResponse,
      EmailCampaignsAdminEngagedLeadsListApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/admin/engaged-leads/`,
        params: {
          campaign_keyword: queryArg.campaignKeyword,
          campaign_keyword__icontains: queryArg.campaignKeywordIcontains,
          city: queryArg.city,
          city__icontains: queryArg.cityIcontains,
          created_at__gte: queryArg.createdAtGte,
          created_at__lte: queryArg.createdAtLte,
          engaged_at__date: queryArg.engagedAtDate,
          engaged_at__gte: queryArg.engagedAtGte,
          engaged_at__lte: queryArg.engagedAtLte,
          engagement_type: queryArg.engagementType,
          industry: queryArg.industry,
          industry__icontains: queryArg.industryIcontains,
          ordering: queryArg.ordering,
          organization_name: queryArg.organizationName,
          organization_name__icontains: queryArg.organizationNameIcontains,
          page: queryArg.page,
          page_size: queryArg.pageSize,
          scraper_type: queryArg.scraperType,
          scraper_type__icontains: queryArg.scraperTypeIcontains,
          search: queryArg.search,
          state: queryArg.state,
        },
      }),
    }),
    emailCampaignsAdminEngagedLeadsRetrieve: build.query<
      EmailCampaignsAdminEngagedLeadsRetrieveApiResponse,
      EmailCampaignsAdminEngagedLeadsRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/admin/engaged-leads/${queryArg.id}/` }),
    }),
    emailCampaignsAdminEngagedLeadsAnalyticsRetrieve: build.query<
      EmailCampaignsAdminEngagedLeadsAnalyticsRetrieveApiResponse,
      EmailCampaignsAdminEngagedLeadsAnalyticsRetrieveApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/admin/engaged-leads/analytics/`,
        params: { days: queryArg.days },
      }),
    }),
    emailCampaignsAdminEngagedLeadsExportCsvRetrieve: build.query<
      EmailCampaignsAdminEngagedLeadsExportCsvRetrieveApiResponse,
      EmailCampaignsAdminEngagedLeadsExportCsvRetrieveApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/admin/engaged-leads/export_csv/` }),
    }),
    emailCampaignsAdminEngagedLeadsExportExcelRetrieve: build.query<
      EmailCampaignsAdminEngagedLeadsExportExcelRetrieveApiResponse,
      EmailCampaignsAdminEngagedLeadsExportExcelRetrieveApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/admin/engaged-leads/export_excel/` }),
    }),
    emailCampaignsAdminEngagedLeadsSummaryRetrieve: build.query<
      EmailCampaignsAdminEngagedLeadsSummaryRetrieveApiResponse,
      EmailCampaignsAdminEngagedLeadsSummaryRetrieveApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/admin/engaged-leads/summary/` }),
    }),
    emailCampaignsEmailAnalyticsCampaignRetrieve: build.query<
      EmailCampaignsEmailAnalyticsCampaignRetrieveApiResponse,
      EmailCampaignsEmailAnalyticsCampaignRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/email-analytics/${queryArg.id}/campaign/` }),
    }),
    emailCampaignsEmailAnalyticsOverviewRetrieve: build.query<
      EmailCampaignsEmailAnalyticsOverviewRetrieveApiResponse,
      EmailCampaignsEmailAnalyticsOverviewRetrieveApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-analytics/overview/`,
        params: { end_date: queryArg.endDate, include_warmup: queryArg.includeWarmup, start_date: queryArg.startDate },
      }),
    }),
    emailCampaignsEmailCampaignsList: build.query<
      EmailCampaignsEmailCampaignsListApiResponse,
      EmailCampaignsEmailCampaignsListApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/`,
        params: {
          campaign_type: queryArg.campaignType,
          ordering: queryArg.ordering,
          schedule_type: queryArg.scheduleType,
          search: queryArg.search,
          status: queryArg.status,
        },
      }),
    }),
    emailCampaignsEmailCampaignsCreate: build.mutation<
      EmailCampaignsEmailCampaignsCreateApiResponse,
      EmailCampaignsEmailCampaignsCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/`,
        method: 'POST',
        body: queryArg.emailCampaignCreateRequest,
      }),
    }),
    emailCampaignsEmailCampaignsRetrieve: build.query<
      EmailCampaignsEmailCampaignsRetrieveApiResponse,
      EmailCampaignsEmailCampaignsRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/email-campaigns/${queryArg.id}/` }),
    }),
    emailCampaignsEmailCampaignsUpdate: build.mutation<
      EmailCampaignsEmailCampaignsUpdateApiResponse,
      EmailCampaignsEmailCampaignsUpdateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/`,
        method: 'PUT',
        body: queryArg.emailCampaignRequest,
      }),
    }),
    emailCampaignsEmailCampaignsPartialUpdate: build.mutation<
      EmailCampaignsEmailCampaignsPartialUpdateApiResponse,
      EmailCampaignsEmailCampaignsPartialUpdateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/`,
        method: 'PATCH',
        body: queryArg.patchedEmailCampaignRequest,
      }),
    }),
    emailCampaignsEmailCampaignsDestroy: build.mutation<
      EmailCampaignsEmailCampaignsDestroyApiResponse,
      EmailCampaignsEmailCampaignsDestroyApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/email-campaigns/${queryArg.id}/`, method: 'DELETE' }),
    }),
    emailCampaignsEmailCampaignsCancelCreate: build.mutation<
      EmailCampaignsEmailCampaignsCancelCreateApiResponse,
      EmailCampaignsEmailCampaignsCancelCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/cancel/`,
        method: 'POST',
        body: queryArg.emailCampaignRequest,
      }),
    }),
    emailCampaignsEmailCampaignsCloneCreate: build.mutation<
      EmailCampaignsEmailCampaignsCloneCreateApiResponse,
      EmailCampaignsEmailCampaignsCloneCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/clone/`,
        method: 'POST',
        body: queryArg.campaignCloneResponseRequest,
      }),
    }),
    emailCampaignsEmailCampaignsLeadsList: build.query<
      EmailCampaignsEmailCampaignsLeadsListApiResponse,
      EmailCampaignsEmailCampaignsLeadsListApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/leads/`,
        params: {
          campaign_type: queryArg.campaignType,
          ordering: queryArg.ordering,
          schedule_type: queryArg.scheduleType,
          search: queryArg.search,
          status: queryArg.status,
        },
      }),
    }),
    emailCampaignsEmailCampaignsLeadsCreate: build.mutation<
      EmailCampaignsEmailCampaignsLeadsCreateApiResponse,
      EmailCampaignsEmailCampaignsLeadsCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/leads/`,
        method: 'POST',
        body: queryArg.emailCampaignRequest,
        params: {
          campaign_type: queryArg.campaignType,
          ordering: queryArg.ordering,
          schedule_type: queryArg.scheduleType,
          search: queryArg.search,
          status: queryArg.status,
        },
      }),
    }),
    emailCampaignsEmailCampaignsPauseCreate: build.mutation<
      EmailCampaignsEmailCampaignsPauseCreateApiResponse,
      EmailCampaignsEmailCampaignsPauseCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/pause/`,
        method: 'POST',
        body: queryArg.emailCampaignRequest,
      }),
    }),
    emailCampaignsEmailCampaignsRequestRefundCreate: build.mutation<
      EmailCampaignsEmailCampaignsRequestRefundCreateApiResponse,
      EmailCampaignsEmailCampaignsRequestRefundCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/request_refund/`,
        method: 'POST',
        body: queryArg.emailCampaignRequest,
      }),
    }),
    emailCampaignsEmailCampaignsResumeCreate: build.mutation<
      EmailCampaignsEmailCampaignsResumeCreateApiResponse,
      EmailCampaignsEmailCampaignsResumeCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/resume/`,
        method: 'POST',
        body: queryArg.emailCampaignRequest,
      }),
    }),
    emailCampaignsEmailCampaignsStartCreate: build.mutation<
      EmailCampaignsEmailCampaignsStartCreateApiResponse,
      EmailCampaignsEmailCampaignsStartCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/start/`,
        method: 'POST',
        body: queryArg.emailCampaignRequest,
      }),
    }),
    emailCampaignsEmailCampaignsStatsRetrieve: build.query<
      EmailCampaignsEmailCampaignsStatsRetrieveApiResponse,
      EmailCampaignsEmailCampaignsStatsRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/email-campaigns/${queryArg.id}/stats/` }),
    }),
    emailCampaignsEmailCampaignsValidateEmailsCreate: build.mutation<
      EmailCampaignsEmailCampaignsValidateEmailsCreateApiResponse,
      EmailCampaignsEmailCampaignsValidateEmailsCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/email-campaigns/${queryArg.id}/validate_emails/`,
        method: 'POST',
        body: queryArg.emailCampaignRequest,
      }),
    }),
    emailCampaignsEmailCampaignsValidationStatusRetrieve: build.query<
      EmailCampaignsEmailCampaignsValidationStatusRetrieveApiResponse,
      EmailCampaignsEmailCampaignsValidationStatusRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/email-campaigns/${queryArg.id}/validation_status/` }),
    }),
    emailCampaignsMasterInboxThreadRetrieve: build.query<
      EmailCampaignsMasterInboxThreadRetrieveApiResponse,
      EmailCampaignsMasterInboxThreadRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/master-inbox/${queryArg.id}/thread/` }),
    }),
    emailCampaignsMasterInboxAccountsRetrieve: build.query<
      EmailCampaignsMasterInboxAccountsRetrieveApiResponse,
      EmailCampaignsMasterInboxAccountsRetrieveApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/master-inbox/accounts/` }),
    }),
    emailCampaignsMasterInboxMarkReadCreate: build.mutation<
      EmailCampaignsMasterInboxMarkReadCreateApiResponse,
      EmailCampaignsMasterInboxMarkReadCreateApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/master-inbox/mark_read/`, method: 'POST' }),
    }),
    emailCampaignsMasterInboxReplyCreate: build.mutation<
      EmailCampaignsMasterInboxReplyCreateApiResponse,
      EmailCampaignsMasterInboxReplyCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/master-inbox/reply/`,
        method: 'POST',
        body: queryArg.emailReplyRequest,
      }),
    }),
    emailCampaignsMasterInboxThreadsRetrieve: build.query<
      EmailCampaignsMasterInboxThreadsRetrieveApiResponse,
      EmailCampaignsMasterInboxThreadsRetrieveApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/master-inbox/threads/`,
        params: {
          account_id: queryArg.accountId,
          campaign_id: queryArg.campaignId,
          end_date: queryArg.endDate,
          page: queryArg.page,
          page_size: queryArg.pageSize,
          search: queryArg.search,
          start_date: queryArg.startDate,
          status: queryArg.status,
        },
      }),
    }),
    emailCampaignsValidationBatchesList: build.query<
      EmailCampaignsValidationBatchesListApiResponse,
      EmailCampaignsValidationBatchesListApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/validation/batches/` }),
    }),
    emailCampaignsValidationCampaignStatusRetrieve: build.query<
      EmailCampaignsValidationCampaignStatusRetrieveApiResponse,
      EmailCampaignsValidationCampaignStatusRetrieveApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/validation/campaign_status/`,
        params: { campaign_id: queryArg.campaignId },
      }),
    }),
    emailCampaignsValidationCheckMxRetrieve: build.query<
      EmailCampaignsValidationCheckMxRetrieveApiResponse,
      EmailCampaignsValidationCheckMxRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/validation/check_mx/`, params: { domain: queryArg.domain } }),
    }),
    emailCampaignsValidationLookupRetrieve: build.query<
      EmailCampaignsValidationLookupRetrieveApiResponse,
      EmailCampaignsValidationLookupRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/email-campaigns/validation/lookup/`, params: { email: queryArg.email } }),
    }),
    emailCampaignsValidationPricingRetrieve: build.query<
      EmailCampaignsValidationPricingRetrieveApiResponse,
      EmailCampaignsValidationPricingRetrieveApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/validation/pricing/` }),
    }),
    emailCampaignsValidationStatsRetrieve: build.query<
      EmailCampaignsValidationStatsRetrieveApiResponse,
      EmailCampaignsValidationStatsRetrieveApiArg
    >({
      query: () => ({ url: `/api/email-campaigns/validation/stats/` }),
    }),
    emailCampaignsValidationValidateBatchCreate: build.mutation<
      EmailCampaignsValidationValidateBatchCreateApiResponse,
      EmailCampaignsValidationValidateBatchCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/validation/validate_batch/`,
        method: 'POST',
        body: queryArg.validateBatchRequestRequest,
      }),
    }),
    emailCampaignsValidationValidateCampaignCreate: build.mutation<
      EmailCampaignsValidationValidateCampaignCreateApiResponse,
      EmailCampaignsValidationValidateCampaignCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/validation/validate_campaign/`,
        method: 'POST',
        body: queryArg.validateCampaignRequestRequest,
      }),
    }),
    emailCampaignsValidationValidateSingleCreate: build.mutation<
      EmailCampaignsValidationValidateSingleCreateApiResponse,
      EmailCampaignsValidationValidateSingleCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/email-campaigns/validation/validate_single/`,
        method: 'POST',
        body: queryArg.validateSingleRequestRequest,
      }),
    }),
    enrichmentBatchCreate: build.mutation<EnrichmentBatchCreateApiResponse, EnrichmentBatchCreateApiArg>({
      query: () => ({ url: `/api/enrichment/batch/`, method: 'POST' }),
    }),
    enrichmentEnhancedCreate: build.mutation<EnrichmentEnhancedCreateApiResponse, EnrichmentEnhancedCreateApiArg>({
      query: () => ({ url: `/api/enrichment/enhanced/`, method: 'POST' }),
    }),
    enrichmentEnhancedBatchCreate: build.mutation<
      EnrichmentEnhancedBatchCreateApiResponse,
      EnrichmentEnhancedBatchCreateApiArg
    >({
      query: () => ({ url: `/api/enrichment/enhanced/batch/`, method: 'POST' }),
    }),
    enrichmentEnhancedStatsRetrieve: build.query<
      EnrichmentEnhancedStatsRetrieveApiResponse,
      EnrichmentEnhancedStatsRetrieveApiArg
    >({
      query: () => ({ url: `/api/enrichment/enhanced/stats/` }),
    }),
    enrichmentFindDomainCreate: build.mutation<EnrichmentFindDomainCreateApiResponse, EnrichmentFindDomainCreateApiArg>(
      {
        query: () => ({ url: `/api/enrichment/find-domain/`, method: 'POST' }),
      },
    ),
    enrichmentJobCreate: build.mutation<EnrichmentJobCreateApiResponse, EnrichmentJobCreateApiArg>({
      query: () => ({ url: `/api/enrichment/job/`, method: 'POST' }),
    }),
    enrichmentJobRetrieve: build.query<EnrichmentJobRetrieveApiResponse, EnrichmentJobRetrieveApiArg>({
      query: queryArg => ({ url: `/api/enrichment/job/${queryArg.taskId}/` }),
    }),
    enrichmentLeadCreate: build.mutation<EnrichmentLeadCreateApiResponse, EnrichmentLeadCreateApiArg>({
      query: queryArg => ({ url: `/api/enrichment/lead/${queryArg.leadId}/`, method: 'POST' }),
    }),
    enrichmentSmartCreate: build.mutation<EnrichmentSmartCreateApiResponse, EnrichmentSmartCreateApiArg>({
      query: () => ({ url: `/api/enrichment/smart/`, method: 'POST' }),
    }),
    enrichmentSmartBatchCreate: build.mutation<EnrichmentSmartBatchCreateApiResponse, EnrichmentSmartBatchCreateApiArg>(
      {
        query: () => ({ url: `/api/enrichment/smart/batch/`, method: 'POST' }),
      },
    ),
    enrichmentStatsRetrieve: build.query<EnrichmentStatsRetrieveApiResponse, EnrichmentStatsRetrieveApiArg>({
      query: () => ({ url: `/api/enrichment/stats/` }),
    }),
    enrichmentVerifyEmailCreate: build.mutation<
      EnrichmentVerifyEmailCreateApiResponse,
      EnrichmentVerifyEmailCreateApiArg
    >({
      query: () => ({ url: `/api/enrichment/verify-email/`, method: 'POST' }),
    }),
    healthRetrieve: build.query<HealthRetrieveApiResponse, HealthRetrieveApiArg>({
      query: () => ({ url: `/api/health/` }),
    }),
    jobsRetrieve: build.query<JobsRetrieveApiResponse, JobsRetrieveApiArg>({
      query: () => ({ url: `/api/jobs/` }),
    }),
    jobsRetrieve2: build.query<JobsRetrieve2ApiResponse, JobsRetrieve2ApiArg>({
      query: queryArg => ({ url: `/api/jobs/${queryArg.id}/` }),
    }),
    leadsList: build.query<LeadsListApiResponse, LeadsListApiArg>({
      query: () => ({ url: `/api/leads/` }),
    }),
    leadsCreate: build.mutation<LeadsCreateApiResponse, LeadsCreateApiArg>({
      query: queryArg => ({ url: `/api/leads/`, method: 'POST', body: queryArg.leadRequest }),
    }),
    leadsRetrieve: build.query<LeadsRetrieveApiResponse, LeadsRetrieveApiArg>({
      query: queryArg => ({ url: `/api/leads/${queryArg.id}/` }),
    }),
    leadsUpdate: build.mutation<LeadsUpdateApiResponse, LeadsUpdateApiArg>({
      query: queryArg => ({ url: `/api/leads/${queryArg.id}/`, method: 'PUT', body: queryArg.leadRequest }),
    }),
    leadsPartialUpdate: build.mutation<LeadsPartialUpdateApiResponse, LeadsPartialUpdateApiArg>({
      query: queryArg => ({ url: `/api/leads/${queryArg.id}/`, method: 'PATCH', body: queryArg.patchedLeadRequest }),
    }),
    leadsDestroy: build.mutation<LeadsDestroyApiResponse, LeadsDestroyApiArg>({
      query: queryArg => ({ url: `/api/leads/${queryArg.id}/`, method: 'DELETE' }),
    }),
    leadsBulkCreateCreate: build.mutation<LeadsBulkCreateCreateApiResponse, LeadsBulkCreateCreateApiArg>({
      query: queryArg => ({ url: `/api/leads/bulk_create/`, method: 'POST', body: queryArg.leadRequest }),
    }),
    leadsDatabaseRetrieve: build.query<LeadsDatabaseRetrieveApiResponse, LeadsDatabaseRetrieveApiArg>({
      query: () => ({ url: `/api/leads/database/` }),
    }),
    leadsDatabaseStatsRetrieve: build.query<LeadsDatabaseStatsRetrieveApiResponse, LeadsDatabaseStatsRetrieveApiArg>({
      query: () => ({ url: `/api/leads/database/stats/` }),
    }),
    leadsFilterOptionsRetrieve: build.query<LeadsFilterOptionsRetrieveApiResponse, LeadsFilterOptionsRetrieveApiArg>({
      query: () => ({ url: `/api/leads/filter-options/` }),
    }),
    leadsMineRetrieve: build.query<LeadsMineRetrieveApiResponse, LeadsMineRetrieveApiArg>({
      query: () => ({ url: `/api/leads/mine/` }),
    }),
    legacyCampaignTypesRetrieve: build.query<LegacyCampaignTypesRetrieveApiResponse, LegacyCampaignTypesRetrieveApiArg>(
      {
        query: () => ({ url: `/api/legacy/campaign-types/` }),
      },
    ),
    legacyScrapersRetrieve: build.query<LegacyScrapersRetrieveApiResponse, LegacyScrapersRetrieveApiArg>({
      query: () => ({ url: `/api/legacy/scrapers/` }),
    }),
    marketplaceRetrieve: build.query<MarketplaceRetrieveApiResponse, MarketplaceRetrieveApiArg>({
      query: () => ({ url: `/api/marketplace/` }),
    }),
    marketplacePurchaseCreate: build.mutation<MarketplacePurchaseCreateApiResponse, MarketplacePurchaseCreateApiArg>({
      query: queryArg => ({ url: `/api/marketplace/${queryArg.id}/purchase/`, method: 'POST' }),
    }),
    marketplaceAnalyticsRetrieve: build.query<
      MarketplaceAnalyticsRetrieveApiResponse,
      MarketplaceAnalyticsRetrieveApiArg
    >({
      query: () => ({ url: `/api/marketplace/analytics/` }),
    }),
    marketplacePurchasedRetrieve: build.query<
      MarketplacePurchasedRetrieveApiResponse,
      MarketplacePurchasedRetrieveApiArg
    >({
      query: () => ({ url: `/api/marketplace/purchased/` }),
    }),
    monitoringList: build.query<MonitoringListApiResponse, MonitoringListApiArg>({
      query: () => ({ url: `/api/monitoring/` }),
    }),
    monitoringRetrieve: build.query<MonitoringRetrieveApiResponse, MonitoringRetrieveApiArg>({
      query: queryArg => ({ url: `/api/monitoring/${queryArg.id}/` }),
    }),
    monitoringCancelCreate: build.mutation<MonitoringCancelCreateApiResponse, MonitoringCancelCreateApiArg>({
      query: queryArg => ({
        url: `/api/monitoring/${queryArg.id}/cancel/`,
        method: 'POST',
        body: queryArg.scrapingJobRequest,
      }),
    }),
    monitoringStatisticsRetrieve: build.query<
      MonitoringStatisticsRetrieveApiResponse,
      MonitoringStatisticsRetrieveApiArg
    >({
      query: () => ({ url: `/api/monitoring/statistics/` }),
    }),
    organizationsList: build.query<OrganizationsListApiResponse, OrganizationsListApiArg>({
      query: () => ({ url: `/api/organizations/` }),
    }),
    organizationsCreate: build.mutation<OrganizationsCreateApiResponse, OrganizationsCreateApiArg>({
      query: queryArg => ({ url: `/api/organizations/`, method: 'POST', body: queryArg.organizationRequest }),
    }),
    organizationsRetrieve: build.query<OrganizationsRetrieveApiResponse, OrganizationsRetrieveApiArg>({
      query: queryArg => ({ url: `/api/organizations/${queryArg.id}/` }),
    }),
    organizationsUpdate: build.mutation<OrganizationsUpdateApiResponse, OrganizationsUpdateApiArg>({
      query: queryArg => ({
        url: `/api/organizations/${queryArg.id}/`,
        method: 'PUT',
        body: queryArg.organizationRequest,
      }),
    }),
    organizationsPartialUpdate: build.mutation<OrganizationsPartialUpdateApiResponse, OrganizationsPartialUpdateApiArg>(
      {
        query: queryArg => ({
          url: `/api/organizations/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedOrganizationRequest,
        }),
      },
    ),
    organizationsDestroy: build.mutation<OrganizationsDestroyApiResponse, OrganizationsDestroyApiArg>({
      query: queryArg => ({ url: `/api/organizations/${queryArg.id}/`, method: 'DELETE' }),
    }),
    organizationsInviteMemberCreate: build.mutation<
      OrganizationsInviteMemberCreateApiResponse,
      OrganizationsInviteMemberCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/organizations/${queryArg.id}/invite_member/`,
        method: 'POST',
        body: queryArg.organizationRequest,
      }),
    }),
    organizationsStatisticsRetrieve: build.query<
      OrganizationsStatisticsRetrieveApiResponse,
      OrganizationsStatisticsRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/organizations/${queryArg.id}/statistics/` }),
    }),
    organizationsCreateOrganizationCreate: build.mutation<
      OrganizationsCreateOrganizationCreateApiResponse,
      OrganizationsCreateOrganizationCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/organizations/create_organization/`,
        method: 'POST',
        body: queryArg.organizationRequest,
      }),
    }),
    organizationsCurrentRetrieve: build.query<
      OrganizationsCurrentRetrieveApiResponse,
      OrganizationsCurrentRetrieveApiArg
    >({
      query: () => ({ url: `/api/organizations/current/` }),
    }),
    proxyRetrieve: build.query<ProxyRetrieveApiResponse, ProxyRetrieveApiArg>({
      query: () => ({ url: `/api/proxy/` }),
    }),
    proxyCreate: build.mutation<ProxyCreateApiResponse, ProxyCreateApiArg>({
      query: () => ({ url: `/api/proxy/`, method: 'POST' }),
    }),
    schemaDebugRetrieve: build.query<SchemaDebugRetrieveApiResponse, SchemaDebugRetrieveApiArg>({
      query: () => ({ url: `/api/schema-debug/` }),
    }),
    scrapekingDatabaseRetrieve: build.query<ScrapekingDatabaseRetrieveApiResponse, ScrapekingDatabaseRetrieveApiArg>({
      query: () => ({ url: `/api/scrapeking-database/` }),
    }),
    scrapekingDatabaseStatsRetrieve: build.query<
      ScrapekingDatabaseStatsRetrieveApiResponse,
      ScrapekingDatabaseStatsRetrieveApiArg
    >({
      query: () => ({ url: `/api/scrapeking-database/stats/` }),
    }),
    scraperTemplatesRetrieve: build.query<ScraperTemplatesRetrieveApiResponse, ScraperTemplatesRetrieveApiArg>({
      query: () => ({ url: `/api/scraper-templates/` }),
    }),
    scrapersRetrieve: build.query<ScrapersRetrieveApiResponse, ScrapersRetrieveApiArg>({
      query: () => ({ url: `/api/scrapers/` }),
    }),
    scrapersApiResultCreate: build.mutation<ScrapersApiResultCreateApiResponse, ScrapersApiResultCreateApiArg>({
      query: () => ({ url: `/api/scrapers/api/result/`, method: 'POST' }),
    }),
    scrapersApiTaskParametersRetrieve: build.query<
      ScrapersApiTaskParametersRetrieveApiResponse,
      ScrapersApiTaskParametersRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/scrapers/api/task/${queryArg.taskId}/parameters/` }),
    }),
    scrapersApiTaskStatusCreate: build.mutation<
      ScrapersApiTaskStatusCreateApiResponse,
      ScrapersApiTaskStatusCreateApiArg
    >({
      query: queryArg => ({ url: `/api/scrapers/api/task/${queryArg.taskId}/status/`, method: 'POST' }),
    }),
    scrapersSchedulesList: build.query<ScrapersSchedulesListApiResponse, ScrapersSchedulesListApiArg>({
      query: queryArg => ({ url: `/api/scrapers/schedules/`, params: { ordering: queryArg.ordering } }),
    }),
    scrapersSchedulesCreate: build.mutation<ScrapersSchedulesCreateApiResponse, ScrapersSchedulesCreateApiArg>({
      query: queryArg => ({ url: `/api/scrapers/schedules/`, method: 'POST', body: queryArg.scraperScheduleRequest }),
    }),
    scrapersSchedulesRetrieve: build.query<ScrapersSchedulesRetrieveApiResponse, ScrapersSchedulesRetrieveApiArg>({
      query: queryArg => ({ url: `/api/scrapers/schedules/${queryArg.id}/` }),
    }),
    scrapersSchedulesUpdate: build.mutation<ScrapersSchedulesUpdateApiResponse, ScrapersSchedulesUpdateApiArg>({
      query: queryArg => ({
        url: `/api/scrapers/schedules/${queryArg.id}/`,
        method: 'PUT',
        body: queryArg.scraperScheduleRequest,
      }),
    }),
    scrapersSchedulesPartialUpdate: build.mutation<
      ScrapersSchedulesPartialUpdateApiResponse,
      ScrapersSchedulesPartialUpdateApiArg
    >({
      query: queryArg => ({
        url: `/api/scrapers/schedules/${queryArg.id}/`,
        method: 'PATCH',
        body: queryArg.patchedScraperScheduleRequest,
      }),
    }),
    scrapersSchedulesDestroy: build.mutation<ScrapersSchedulesDestroyApiResponse, ScrapersSchedulesDestroyApiArg>({
      query: queryArg => ({ url: `/api/scrapers/schedules/${queryArg.id}/`, method: 'DELETE' }),
    }),
    scrapersSchedulesActivateCreate: build.mutation<
      ScrapersSchedulesActivateCreateApiResponse,
      ScrapersSchedulesActivateCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/scrapers/schedules/${queryArg.id}/activate/`,
        method: 'POST',
        body: queryArg.scraperScheduleRequest,
      }),
    }),
    scrapersSchedulesDeactivateCreate: build.mutation<
      ScrapersSchedulesDeactivateCreateApiResponse,
      ScrapersSchedulesDeactivateCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/scrapers/schedules/${queryArg.id}/deactivate/`,
        method: 'POST',
        body: queryArg.scraperScheduleRequest,
      }),
    }),
    scrapersSchedulesRunNowCreate: build.mutation<
      ScrapersSchedulesRunNowCreateApiResponse,
      ScrapersSchedulesRunNowCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/scrapers/schedules/${queryArg.id}/run_now/`,
        method: 'POST',
        body: queryArg.scraperScheduleRequest,
      }),
    }),
    scrapersTasksList: build.query<ScrapersTasksListApiResponse, ScrapersTasksListApiArg>({
      query: queryArg => ({
        url: `/api/scrapers/tasks/`,
        params: { ordering: queryArg.ordering, search: queryArg.search },
      }),
    }),
    scrapersTasksCreate: build.mutation<ScrapersTasksCreateApiResponse, ScrapersTasksCreateApiArg>({
      query: queryArg => ({ url: `/api/scrapers/tasks/`, method: 'POST', body: queryArg.scraperTaskRequest }),
    }),
    scrapersTasksRetrieve: build.query<ScrapersTasksRetrieveApiResponse, ScrapersTasksRetrieveApiArg>({
      query: queryArg => ({ url: `/api/scrapers/tasks/${queryArg.id}/` }),
    }),
    scrapersTasksUpdate: build.mutation<ScrapersTasksUpdateApiResponse, ScrapersTasksUpdateApiArg>({
      query: queryArg => ({
        url: `/api/scrapers/tasks/${queryArg.id}/`,
        method: 'PUT',
        body: queryArg.scraperTaskRequest,
      }),
    }),
    scrapersTasksPartialUpdate: build.mutation<ScrapersTasksPartialUpdateApiResponse, ScrapersTasksPartialUpdateApiArg>(
      {
        query: queryArg => ({
          url: `/api/scrapers/tasks/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedScraperTaskRequest,
        }),
      },
    ),
    scrapersTasksDestroy: build.mutation<ScrapersTasksDestroyApiResponse, ScrapersTasksDestroyApiArg>({
      query: queryArg => ({ url: `/api/scrapers/tasks/${queryArg.id}/`, method: 'DELETE' }),
    }),
    scrapersTasksCancelCreate: build.mutation<ScrapersTasksCancelCreateApiResponse, ScrapersTasksCancelCreateApiArg>({
      query: queryArg => ({
        url: `/api/scrapers/tasks/${queryArg.id}/cancel/`,
        method: 'POST',
        body: queryArg.scraperTaskRequest,
      }),
    }),
    scrapersTasksResultsRetrieve: build.query<
      ScrapersTasksResultsRetrieveApiResponse,
      ScrapersTasksResultsRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/scrapers/tasks/${queryArg.id}/results/` }),
    }),
    scrapersTasksRetryCreate: build.mutation<ScrapersTasksRetryCreateApiResponse, ScrapersTasksRetryCreateApiArg>({
      query: queryArg => ({
        url: `/api/scrapers/tasks/${queryArg.id}/retry/`,
        method: 'POST',
        body: queryArg.scraperTaskRequest,
      }),
    }),
    scrapersTasksStatusCheckRetrieve: build.query<
      ScrapersTasksStatusCheckRetrieveApiResponse,
      ScrapersTasksStatusCheckRetrieveApiArg
    >({
      query: queryArg => ({ url: `/api/scrapers/tasks/${queryArg.id}/status_check/` }),
    }),
    scrapersTasksExecuteCampaignCreate: build.mutation<
      ScrapersTasksExecuteCampaignCreateApiResponse,
      ScrapersTasksExecuteCampaignCreateApiArg
    >({
      query: queryArg => ({
        url: `/api/scrapers/tasks/execute_campaign/`,
        method: 'POST',
        body: queryArg.scraperTaskRequest,
      }),
    }),
    scrapersTasksStatsRetrieve: build.query<ScrapersTasksStatsRetrieveApiResponse, ScrapersTasksStatsRetrieveApiArg>({
      query: () => ({ url: `/api/scrapers/tasks/stats/` }),
    }),
    subscriptionPackagesRetrieve: build.query<
      SubscriptionPackagesRetrieveApiResponse,
      SubscriptionPackagesRetrieveApiArg
    >({
      query: () => ({ url: `/api/subscription/packages/` }),
    }),
    subscriptionPricesRetrieve: build.query<SubscriptionPricesRetrieveApiResponse, SubscriptionPricesRetrieveApiArg>({
      query: () => ({ url: `/api/subscription/prices/` }),
    }),
    subscriptionSubscriptionRetrieve: build.query<
      SubscriptionSubscriptionRetrieveApiResponse,
      SubscriptionSubscriptionRetrieveApiArg
    >({
      query: () => ({ url: `/api/subscription/subscription/` }),
    }),
    templatesRetrieve: build.query<TemplatesRetrieveApiResponse, TemplatesRetrieveApiArg>({
      query: () => ({ url: `/api/templates/` }),
    }),
    templatesRetrieve2: build.query<TemplatesRetrieve2ApiResponse, TemplatesRetrieve2ApiArg>({
      query: queryArg => ({ url: `/api/templates/${queryArg.id}/` }),
    }),
    testRetrieve: build.query<TestRetrieveApiResponse, TestRetrieveApiArg>({
      query: () => ({ url: `/api/test/` }),
    }),
    testProxyRetrieve: build.query<TestProxyRetrieveApiResponse, TestProxyRetrieveApiArg>({
      query: () => ({ url: `/api/test-proxy/` }),
    }),
    usersMeRetrieve: build.query<UsersMeRetrieveApiResponse, UsersMeRetrieveApiArg>({
      query: () => ({ url: `/api/users/me/` }),
    }),
    usersMePartialUpdate: build.mutation<UsersMePartialUpdateApiResponse, UsersMePartialUpdateApiArg>({
      query: queryArg => ({ url: `/api/users/me/`, method: 'PATCH', body: queryArg.patchedUserRequest }),
    }),
  }),
  overrideExisting: false,
});

// Enhance the generated API with cache tags for automatic refetching
const enhancedApi = injectedRtkApi.enhanceEndpoints({
  endpoints: {
    // Campaign queries - provide tags
    campaignsList: {
      providesTags: [Tag.CAMPAIGN],
    },
    campaignsRetrieve: {
      providesTags: (_result, _error, arg) => [{ type: Tag.CAMPAIGN, id: arg.id }],
    },
    // Campaign mutations - invalidate tags to trigger refetch
    campaignsCreate: {
      invalidatesTags: [Tag.CAMPAIGN],
    },
    campaignsUpdate: {
      invalidatesTags: (_result, _error, arg) => [Tag.CAMPAIGN, { type: Tag.CAMPAIGN, id: arg.id }],
    },
    campaignsPartialUpdate: {
      invalidatesTags: (_result, _error, arg) => [Tag.CAMPAIGN, { type: Tag.CAMPAIGN, id: arg.id }],
    },
    campaignsDestroy: {
      invalidatesTags: [Tag.CAMPAIGN],
    },
    campaignsStartCreate: {
      invalidatesTags: (_result, _error, arg) => [Tag.CAMPAIGN, { type: Tag.CAMPAIGN, id: arg.id }],
    },
    campaignsStopCreate: {
      invalidatesTags: (_result, _error, arg) => [Tag.CAMPAIGN, { type: Tag.CAMPAIGN, id: arg.id }],
    },
  },
});

export { enhancedApi as generatedApi };
export type GetApiApiDocsJsonApiResponse = unknown;
export type GetApiApiDocsJsonApiArg = void;
export type AuthChangePasswordCreateApiResponse = unknown;
export type AuthChangePasswordCreateApiArg = {
  body: {
    old_password: string;
    new_password: string;
  };
};
export type AuthConfirmEmailCreateApiResponse = unknown;
export type AuthConfirmEmailCreateApiArg = {
  body: {
    email: string;
    code: string;
  };
};
export type AuthForgotPasswordCreateApiResponse = unknown;
export type AuthForgotPasswordCreateApiArg = {
  body: {
    email: string;
  };
};
export type AuthIsVerifiedRetrieveApiResponse = unknown;
export type AuthIsVerifiedRetrieveApiArg = void;
export type AuthLoginCreateApiResponse = /** status 200  */ {
  user?: object;
  refresh?: string;
  access?: string;
};
export type AuthLoginCreateApiArg = {
  body: {
    username: string;
    password: string;
  };
};
export type AuthRefreshCreateApiResponse = /** status 200  */ TokenRefreshRead;
export type AuthRefreshCreateApiArg = {
  tokenRefreshRequest: TokenRefreshRequestWrite;
};
export type AuthRegisterCreateApiResponse = /** status 201  */ UserRead;
export type AuthRegisterCreateApiArg = {
  userRegistrationRequest: UserRegistrationRequestWrite;
};
export type AuthResendCodeCreateApiResponse = unknown;
export type AuthResendCodeCreateApiArg = {
  body: {
    email: string;
  };
};
export type AuthResetPasswordCreateApiResponse = unknown;
export type AuthResetPasswordCreateApiArg = {
  body: {
    uid: string;
    token: string;
    new_password: string;
  };
};
export type AuthVerifyEmailRetrieveApiResponse = unknown;
export type AuthVerifyEmailRetrieveApiArg = {
  /** Email verification token */
  token: string;
};
export type BillingAddTokensCreateApiResponse = /** status 200  */ AddTokensResponse;
export type BillingAddTokensCreateApiArg = {
  addTokensRequestRequest: AddTokensRequestRequest;
};
export type BillingAddTokensCreate2ApiResponse = unknown;
export type BillingAddTokensCreate2ApiArg = void;
export type BillingBalanceRetrieveApiResponse = unknown;
export type BillingBalanceRetrieveApiArg = void;
export type BillingCheckoutCreateApiResponse = /** status 200  */ CheckoutResponse;
export type BillingCheckoutCreateApiArg = {
  checkoutRequestRequest: CheckoutRequestRequest;
};
export type BillingDebouncePricingRetrieveApiResponse = /** status 200  */ {
  /** Cost for standard verification */
  standard?: number;
  /** Cost for deep verification */
  deep?: number;
};
export type BillingDebouncePricingRetrieveApiArg = void;
export type BillingPlansRetrieveApiResponse = /** status 200  */ {
  plans?: {
    key?: string;
    name?: string;
    price?: number;
    tokens?: number;
    features?: string[];
  }[];
};
export type BillingPlansRetrieveApiArg = void;
export type BillingSubscriptionCancelCreateApiResponse = /** status 200  */ {
  success?: boolean;
  message?: string;
};
export type BillingSubscriptionCancelCreateApiArg = void;
export type BillingTokenCostsRetrieveApiResponse = /** status 200  */ {
  /** Token costs per action */
  costs?: object;
  /** Whether warmup is free */
  warmup_free?: boolean;
  /** Current subscription status */
  subscription_status?: string;
  /** DeBounce pricing info */
  debounce_pricing?: object;
};
export type BillingTokenCostsRetrieveApiArg = void;
export type BillingTransactionsRetrieveApiResponse = /** status 200  */ {
  transactions?: {
    id?: string;
    transaction_type?: string;
    amount?: number;
    balance_after?: number;
    description?: string;
    created_at?: string;
  }[];
};
export type BillingTransactionsRetrieveApiArg = void;
export type BillingVerifyEmailsCreateApiResponse = /** status 200  */ VerifyEmailsResponse;
export type BillingVerifyEmailsCreateApiArg = {
  verifyEmailsRequestRequest: VerifyEmailsRequestRequest;
};
export type BillingWebhookStripeCreateApiResponse = unknown;
export type BillingWebhookStripeCreateApiArg = void;
export type CampaignFiltersRetrieveApiResponse = unknown;
export type CampaignFiltersRetrieveApiArg = {
  campaignTypeId: number;
};
export type CampaignSourcesRetrieveApiResponse = unknown;
export type CampaignSourcesRetrieveApiArg = {
  campaignTypeId: number;
};
export type CampaignTypesRetrieveApiResponse = unknown;
export type CampaignTypesRetrieveApiArg = void;
export type CampaignTypesProperRetrieveApiResponse = unknown;
export type CampaignTypesProperRetrieveApiArg = void;
export type CampaignsListApiResponse = /** status 200  */ {
  data: CampaignRead[];
  total: number;
  page: number;
  limit: number;
};
export type CampaignsListApiArg = {
  page?: number;
  limit?: number;
};
export type CampaignsCreateApiResponse = /** status 201  */ CampaignRead;
export type CampaignsCreateApiArg = {
  campaignRequest: CampaignRequestWrite;
};
export type CampaignsRetrieveApiResponse = /** status 200  */ CampaignRead;
export type CampaignsRetrieveApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
};
export type CampaignsUpdateApiResponse = /** status 200  */ CampaignRead;
export type CampaignsUpdateApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
  campaignRequest: CampaignRequestWrite;
};
export type CampaignsPartialUpdateApiResponse = /** status 200  */ CampaignRead;
export type CampaignsPartialUpdateApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
  patchedCampaignRequest: PatchedCampaignRequestWrite;
};
export type CampaignsDestroyApiResponse = unknown;
export type CampaignsDestroyApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
};
export type CampaignsFlowConfigCreateApiResponse = /** status 200  */ any;
export type CampaignsFlowConfigCreateApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
  flowConfigRequest: FlowConfigRequest;
};
export type CampaignsLeadsRetrieveApiResponse = /** status 200  */ CampaignRead;
export type CampaignsLeadsRetrieveApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
};
export type CampaignsLinkEmailCreateApiResponse = /** status 200  */ any;
export type CampaignsLinkEmailCreateApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
  emailLinkRequest: EmailLinkRequest;
};
export type CampaignsPublishLeadsCreateApiResponse = /** status 200  */ CampaignRead;
export type CampaignsPublishLeadsCreateApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
  campaignRequest: CampaignRequestWrite;
};
export type CampaignsStartCreateApiResponse = /** status 200  */ CampaignRead;
export type CampaignsStartCreateApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
  campaignRequest: CampaignRequestWrite;
};
export type CampaignsStatusRetrieveApiResponse = /** status 200  */ CampaignStatus;
export type CampaignsStatusRetrieveApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
};
export type CampaignsStopCreateApiResponse = /** status 200  */ CampaignRead;
export type CampaignsStopCreateApiArg = {
  /** A UUID string identifying this campaign. */
  id: string;
  campaignRequest: CampaignRequestWrite;
};
export type CampaignsTypesRetrieveApiResponse = unknown;
export type CampaignsTypesRetrieveApiArg = void;
export type EmailCampaignsAccountsListApiResponse = /** status 200  */ EmailAccountResponse[];
export type EmailCampaignsAccountsListApiArg = void;
export type EmailCampaignsAccountsCreateApiResponse = /** status 201  */ EmailAccountResponse;
export type EmailCampaignsAccountsCreateApiArg = {
  emailAccountCreateRequestRequest: EmailAccountCreateRequestRequestWrite;
};
export type EmailCampaignsAccountsRetrieveApiResponse = /** status 200  */ {
  id?: string;
  email?: string;
  fromName?: string;
  providerType?: string;
  status?: string;
  warmupProfile?: object;
};
export type EmailCampaignsAccountsRetrieveApiArg = {
  accountId: string;
};
export type EmailCampaignsAccountsUpdateApiResponse = /** status 200  */ EmailAccountResponse;
export type EmailCampaignsAccountsUpdateApiArg = {
  accountId: string;
  emailAccountCreateRequestRequest: EmailAccountCreateRequestRequestWrite;
};
export type EmailCampaignsAccountsDestroyApiResponse = unknown;
export type EmailCampaignsAccountsDestroyApiArg = {
  accountId: string;
};
export type EmailCampaignsAccountsPauseWarmupCreateApiResponse = /** status 200  */ {
  message?: string;
};
export type EmailCampaignsAccountsPauseWarmupCreateApiArg = {
  accountId: string;
};
export type EmailCampaignsAccountsStartWarmupCreateApiResponse = /** status 200  */ {
  message?: string;
};
export type EmailCampaignsAccountsStartWarmupCreateApiArg = {
  accountId: string;
  startWarmupRequestRequest: StartWarmupRequestRequest;
};
export type EmailCampaignsAccountsTestCreateApiResponse = /** status 200  */ TestConnectionResponse;
export type EmailCampaignsAccountsTestCreateApiArg = {
  accountId: string;
};
export type EmailCampaignsAccountsWarmupStatusRetrieveApiResponse = /** status 200  */ {
  enabled?: boolean;
  completed?: boolean;
  warmupDurationDays?: number;
  totalWarmupPerDay?: number;
  dailyRampUp?: number;
  replyRatePercentage?: number;
  warmupReputation?: string;
  warmupStats?: any;
};
export type EmailCampaignsAccountsWarmupStatusRetrieveApiArg = {
  accountId: string;
};
export type EmailCampaignsAccountsImapSmtpCreateApiResponse = /** status 201  */ EmailAccountResponse;
export type EmailCampaignsAccountsImapSmtpCreateApiArg = {
  emailAccountCreateRequestRequest: EmailAccountCreateRequestRequestWrite;
};
export type EmailCampaignsAccountsOauthGmailCallbackCreateApiResponse = /** status 200  */ MessageResponse;
export type EmailCampaignsAccountsOauthGmailCallbackCreateApiArg = void;
export type EmailCampaignsAccountsOauthGmailInitCreateApiResponse = /** status 200  */ OAuthInitResponse;
export type EmailCampaignsAccountsOauthGmailInitCreateApiArg = void;
export type EmailCampaignsAccountsOauthOutlookCallbackCreateApiResponse = /** status 200  */ MessageResponse;
export type EmailCampaignsAccountsOauthOutlookCallbackCreateApiArg = void;
export type EmailCampaignsAccountsOauthOutlookInitCreateApiResponse = /** status 200  */ OAuthInitResponse;
export type EmailCampaignsAccountsOauthOutlookInitCreateApiArg = void;
export type EmailCampaignsAdminEngagedLeadsListApiResponse = /** status 200  */ PaginatedAdminEngagedLeadListRead;
export type EmailCampaignsAdminEngagedLeadsListApiArg = {
  campaignKeyword?: string;
  campaignKeywordIcontains?: string;
  city?: string;
  cityIcontains?: string;
  createdAtGte?: string;
  createdAtLte?: string;
  engagedAtDate?: string;
  engagedAtGte?: string;
  engagedAtLte?: string;
  /** * `opened` - Email Opened
   * `replied` - Email Replied
   * `clicked` - Link Clicked */
  engagementType?: 'clicked' | 'opened' | 'replied';
  industry?: string;
  industryIcontains?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  organizationName?: string;
  organizationNameIcontains?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  scraperType?: string;
  scraperTypeIcontains?: string;
  /** A search term. */
  search?: string;
  state?: string;
};
export type EmailCampaignsAdminEngagedLeadsRetrieveApiResponse = /** status 200  */ AdminEngagedLeadRead;
export type EmailCampaignsAdminEngagedLeadsRetrieveApiArg = {
  /** A UUID string identifying this Admin Engaged Lead. */
  id: string;
};
export type EmailCampaignsAdminEngagedLeadsAnalyticsRetrieveApiResponse = /** status 200  */ AdminEngagedLeadRead;
export type EmailCampaignsAdminEngagedLeadsAnalyticsRetrieveApiArg = {
  /** Number of days to analyze (default: 30) */
  days?: number;
};
export type EmailCampaignsAdminEngagedLeadsExportCsvRetrieveApiResponse = /** status 200  */ AdminEngagedLeadRead;
export type EmailCampaignsAdminEngagedLeadsExportCsvRetrieveApiArg = void;
export type EmailCampaignsAdminEngagedLeadsExportExcelRetrieveApiResponse = /** status 200  */ AdminEngagedLeadRead;
export type EmailCampaignsAdminEngagedLeadsExportExcelRetrieveApiArg = void;
export type EmailCampaignsAdminEngagedLeadsSummaryRetrieveApiResponse = /** status 200  */ AdminEngagedLeadRead;
export type EmailCampaignsAdminEngagedLeadsSummaryRetrieveApiArg = void;
export type EmailCampaignsEmailAnalyticsCampaignRetrieveApiResponse = /** status 200  */ CampaignAnalytics;
export type EmailCampaignsEmailAnalyticsCampaignRetrieveApiArg = {
  id: string;
};
export type EmailCampaignsEmailAnalyticsOverviewRetrieveApiResponse = /** status 200  */ AnalyticsOverview;
export type EmailCampaignsEmailAnalyticsOverviewRetrieveApiArg = {
  /** End date filter (ISO format) */
  endDate?: string;
  /** Include warmup emails in stats (default: true) */
  includeWarmup?: boolean;
  /** Start date filter (ISO format) */
  startDate?: string;
};
export type EmailCampaignsEmailCampaignsListApiResponse = /** status 200  */ EmailCampaignRead[];
export type EmailCampaignsEmailCampaignsListApiArg = {
  campaignType?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  scheduleType?: string;
  /** A search term. */
  search?: string;
  /** * `draft` - Draft
   * `scheduled` - Scheduled
   * `running` - Running
   * `paused` - Paused
   * `completed` - Completed
   * `cancelled` - Cancelled */
  status?: 'cancelled' | 'completed' | 'draft' | 'paused' | 'running' | 'scheduled';
};
export type EmailCampaignsEmailCampaignsCreateApiResponse = /** status 201  */ EmailCampaignCreate;
export type EmailCampaignsEmailCampaignsCreateApiArg = {
  emailCampaignCreateRequest: EmailCampaignCreateRequest;
};
export type EmailCampaignsEmailCampaignsRetrieveApiResponse = /** status 200  */ EmailCampaignRead;
export type EmailCampaignsEmailCampaignsRetrieveApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
};
export type EmailCampaignsEmailCampaignsUpdateApiResponse = /** status 200  */ EmailCampaignRead;
export type EmailCampaignsEmailCampaignsUpdateApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
  emailCampaignRequest: EmailCampaignRequest;
};
export type EmailCampaignsEmailCampaignsPartialUpdateApiResponse = /** status 200  */ EmailCampaignRead;
export type EmailCampaignsEmailCampaignsPartialUpdateApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
  patchedEmailCampaignRequest: PatchedEmailCampaignRequest;
};
export type EmailCampaignsEmailCampaignsDestroyApiResponse = unknown;
export type EmailCampaignsEmailCampaignsDestroyApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
};
export type EmailCampaignsEmailCampaignsCancelCreateApiResponse = /** status 200 Campaign cancelled */ MessageResponse;
export type EmailCampaignsEmailCampaignsCancelCreateApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
  emailCampaignRequest: EmailCampaignRequest;
};
export type EmailCampaignsEmailCampaignsCloneCreateApiResponse = /** status 201  */ EmailCampaignRead;
export type EmailCampaignsEmailCampaignsCloneCreateApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
  campaignCloneResponseRequest: CampaignCloneResponseRequest;
};
export type EmailCampaignsEmailCampaignsLeadsListApiResponse =
  /** status 200  */
  EmailCampaignLeadRead[] | /** status 201  */ AddLeadsResponse;
export type EmailCampaignsEmailCampaignsLeadsListApiArg = {
  campaignType?: string;
  /** A UUID string identifying this Email Campaign. */
  id: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  scheduleType?: string;
  /** A search term. */
  search?: string;
  /** * `draft` - Draft
   * `scheduled` - Scheduled
   * `running` - Running
   * `paused` - Paused
   * `completed` - Completed
   * `cancelled` - Cancelled */
  status?: 'cancelled' | 'completed' | 'draft' | 'paused' | 'running' | 'scheduled';
};
export type EmailCampaignsEmailCampaignsLeadsCreateApiResponse =
  /** status 200  */
  EmailCampaignLeadRead[] | /** status 201  */ AddLeadsResponse;
export type EmailCampaignsEmailCampaignsLeadsCreateApiArg = {
  campaignType?: string;
  /** A UUID string identifying this Email Campaign. */
  id: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  scheduleType?: string;
  /** A search term. */
  search?: string;
  /** * `draft` - Draft
   * `scheduled` - Scheduled
   * `running` - Running
   * `paused` - Paused
   * `completed` - Completed
   * `cancelled` - Cancelled */
  status?: 'cancelled' | 'completed' | 'draft' | 'paused' | 'running' | 'scheduled';
  emailCampaignRequest: EmailCampaignRequest;
};
export type EmailCampaignsEmailCampaignsPauseCreateApiResponse = /** status 200 Campaign paused */ MessageResponse;
export type EmailCampaignsEmailCampaignsPauseCreateApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
  emailCampaignRequest: EmailCampaignRequest;
};
export type EmailCampaignsEmailCampaignsRequestRefundCreateApiResponse = /** status 201  */ EmailCampaignRefundRead;
export type EmailCampaignsEmailCampaignsRequestRefundCreateApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
  emailCampaignRequest: EmailCampaignRequest;
};
export type EmailCampaignsEmailCampaignsResumeCreateApiResponse = /** status 200 Campaign resumed */ MessageResponse;
export type EmailCampaignsEmailCampaignsResumeCreateApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
  emailCampaignRequest: EmailCampaignRequest;
};
export type EmailCampaignsEmailCampaignsStartCreateApiResponse =
  /** status 200 Campaign started */
  MessageResponse | /** status 202 Validation in progress */ MessageResponse;
export type EmailCampaignsEmailCampaignsStartCreateApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
  emailCampaignRequest: EmailCampaignRequest;
};
export type EmailCampaignsEmailCampaignsStatsRetrieveApiResponse = /** status 200  */ EmailCampaignStatsRead;
export type EmailCampaignsEmailCampaignsStatsRetrieveApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
};
export type EmailCampaignsEmailCampaignsValidateEmailsCreateApiResponse = /** status 202  */ ValidationTaskResponse;
export type EmailCampaignsEmailCampaignsValidateEmailsCreateApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
  emailCampaignRequest: EmailCampaignRequest;
};
export type EmailCampaignsEmailCampaignsValidationStatusRetrieveApiResponse = /** status 200  */ ValidationStatus;
export type EmailCampaignsEmailCampaignsValidationStatusRetrieveApiArg = {
  /** A UUID string identifying this Email Campaign. */
  id: string;
};
export type EmailCampaignsMasterInboxThreadRetrieveApiResponse = /** status 200  */ EmailThread;
export type EmailCampaignsMasterInboxThreadRetrieveApiArg = {
  id: string;
};
export type EmailCampaignsMasterInboxAccountsRetrieveApiResponse = /** status 200  */ EmailAccountsList;
export type EmailCampaignsMasterInboxAccountsRetrieveApiArg = void;
export type EmailCampaignsMasterInboxMarkReadCreateApiResponse = /** status 200  */ MessageResponse;
export type EmailCampaignsMasterInboxMarkReadCreateApiArg = void;
export type EmailCampaignsMasterInboxReplyCreateApiResponse = /** status 200  */ MessageResponse;
export type EmailCampaignsMasterInboxReplyCreateApiArg = {
  emailReplyRequest: EmailReplyRequest;
};
export type EmailCampaignsMasterInboxThreadsRetrieveApiResponse = /** status 200  */ MasterInbox;
export type EmailCampaignsMasterInboxThreadsRetrieveApiArg = {
  /** Filter by email account ID */
  accountId?: string;
  /** Filter by campaign ID */
  campaignId?: string;
  /** End date filter (ISO format) */
  endDate?: string;
  /** Page number */
  page?: number;
  /** Page size */
  pageSize?: number;
  /** Search in subject and body */
  search?: string;
  /** Start date filter (ISO format) */
  startDate?: string;
  /** Filter by thread status */
  status?: string;
};
export type EmailCampaignsValidationBatchesListApiResponse = /** status 200  */ ValidationBatchRead[];
export type EmailCampaignsValidationBatchesListApiArg = void;
export type EmailCampaignsValidationCampaignStatusRetrieveApiResponse = /** status 200  */ CampaignValidationSummary;
export type EmailCampaignsValidationCampaignStatusRetrieveApiArg = {
  campaignId: string;
};
export type EmailCampaignsValidationCheckMxRetrieveApiResponse = /** status 200  */ MxCheckResponse;
export type EmailCampaignsValidationCheckMxRetrieveApiArg = {
  /** Domain to check */
  domain?: string;
};
export type EmailCampaignsValidationLookupRetrieveApiResponse = /** status 200  */ EmailValidationResultRead;
export type EmailCampaignsValidationLookupRetrieveApiArg = {
  email: string;
};
export type EmailCampaignsValidationPricingRetrieveApiResponse = /** status 200  */ ValidationPricing;
export type EmailCampaignsValidationPricingRetrieveApiArg = void;
export type EmailCampaignsValidationStatsRetrieveApiResponse = /** status 200  */ ValidationStats;
export type EmailCampaignsValidationStatsRetrieveApiArg = void;
export type EmailCampaignsValidationValidateBatchCreateApiResponse = /** status 200  */ ValidateBatchResponse;
export type EmailCampaignsValidationValidateBatchCreateApiArg = {
  validateBatchRequestRequest: ValidateBatchRequestRequest;
};
export type EmailCampaignsValidationValidateCampaignCreateApiResponse = /** status 200  */ CampaignValidationSummary;
export type EmailCampaignsValidationValidateCampaignCreateApiArg = {
  validateCampaignRequestRequest: ValidateCampaignRequestRequest;
};
export type EmailCampaignsValidationValidateSingleCreateApiResponse = /** status 200  */ ValidateSingleResponse;
export type EmailCampaignsValidationValidateSingleCreateApiArg = {
  validateSingleRequestRequest: ValidateSingleRequestRequest;
};
export type EnrichmentBatchCreateApiResponse = unknown;
export type EnrichmentBatchCreateApiArg = void;
export type EnrichmentEnhancedCreateApiResponse = unknown;
export type EnrichmentEnhancedCreateApiArg = void;
export type EnrichmentEnhancedBatchCreateApiResponse = unknown;
export type EnrichmentEnhancedBatchCreateApiArg = void;
export type EnrichmentEnhancedStatsRetrieveApiResponse = unknown;
export type EnrichmentEnhancedStatsRetrieveApiArg = void;
export type EnrichmentFindDomainCreateApiResponse = unknown;
export type EnrichmentFindDomainCreateApiArg = void;
export type EnrichmentJobCreateApiResponse = unknown;
export type EnrichmentJobCreateApiArg = void;
export type EnrichmentJobRetrieveApiResponse = unknown;
export type EnrichmentJobRetrieveApiArg = {
  taskId: string;
};
export type EnrichmentLeadCreateApiResponse = unknown;
export type EnrichmentLeadCreateApiArg = {
  leadId: string;
};
export type EnrichmentSmartCreateApiResponse = unknown;
export type EnrichmentSmartCreateApiArg = void;
export type EnrichmentSmartBatchCreateApiResponse = unknown;
export type EnrichmentSmartBatchCreateApiArg = void;
export type EnrichmentStatsRetrieveApiResponse = unknown;
export type EnrichmentStatsRetrieveApiArg = void;
export type EnrichmentVerifyEmailCreateApiResponse = unknown;
export type EnrichmentVerifyEmailCreateApiArg = void;
export type HealthRetrieveApiResponse = unknown;
export type HealthRetrieveApiArg = void;
export type JobsRetrieveApiResponse = unknown;
export type JobsRetrieveApiArg = void;
export type JobsRetrieve2ApiResponse = unknown;
export type JobsRetrieve2ApiArg = {
  id: string;
};
export type LeadsListApiResponse = /** status 200  */ LeadRead[];
export type LeadsListApiArg = void;
export type LeadsCreateApiResponse = /** status 201  */ LeadRead;
export type LeadsCreateApiArg = {
  leadRequest: LeadRequest;
};
export type LeadsRetrieveApiResponse = /** status 200  */ LeadRead;
export type LeadsRetrieveApiArg = {
  /** A UUID string identifying this lead. */
  id: string;
};
export type LeadsUpdateApiResponse = /** status 200  */ LeadRead;
export type LeadsUpdateApiArg = {
  /** A UUID string identifying this lead. */
  id: string;
  leadRequest: LeadRequest;
};
export type LeadsPartialUpdateApiResponse = /** status 200  */ LeadRead;
export type LeadsPartialUpdateApiArg = {
  /** A UUID string identifying this lead. */
  id: string;
  patchedLeadRequest: PatchedLeadRequest;
};
export type LeadsDestroyApiResponse = unknown;
export type LeadsDestroyApiArg = {
  /** A UUID string identifying this lead. */
  id: string;
};
export type LeadsBulkCreateCreateApiResponse = /** status 200  */ LeadRead;
export type LeadsBulkCreateCreateApiArg = {
  leadRequest: LeadRequest;
};
export type LeadsDatabaseRetrieveApiResponse = unknown;
export type LeadsDatabaseRetrieveApiArg = void;
export type LeadsDatabaseStatsRetrieveApiResponse = unknown;
export type LeadsDatabaseStatsRetrieveApiArg = void;
export type LeadsFilterOptionsRetrieveApiResponse = unknown;
export type LeadsFilterOptionsRetrieveApiArg = void;
export type LeadsMineRetrieveApiResponse = /** status 200  */ LeadRead;
export type LeadsMineRetrieveApiArg = void;
export type LegacyCampaignTypesRetrieveApiResponse = unknown;
export type LegacyCampaignTypesRetrieveApiArg = void;
export type LegacyScrapersRetrieveApiResponse = unknown;
export type LegacyScrapersRetrieveApiArg = void;
export type MarketplaceRetrieveApiResponse = unknown;
export type MarketplaceRetrieveApiArg = void;
export type MarketplacePurchaseCreateApiResponse = unknown;
export type MarketplacePurchaseCreateApiArg = {
  id: string;
};
export type MarketplaceAnalyticsRetrieveApiResponse = unknown;
export type MarketplaceAnalyticsRetrieveApiArg = void;
export type MarketplacePurchasedRetrieveApiResponse = unknown;
export type MarketplacePurchasedRetrieveApiArg = void;
export type MonitoringListApiResponse = /** status 200  */ ScrapingJobRead[];
export type MonitoringListApiArg = void;
export type MonitoringRetrieveApiResponse = /** status 200  */ ScrapingJobRead;
export type MonitoringRetrieveApiArg = {
  /** A UUID string identifying this scraping job. */
  id: string;
};
export type MonitoringCancelCreateApiResponse = /** status 200  */ ScrapingJobRead;
export type MonitoringCancelCreateApiArg = {
  /** A UUID string identifying this scraping job. */
  id: string;
  scrapingJobRequest: ScrapingJobRequest;
};
export type MonitoringStatisticsRetrieveApiResponse = /** status 200  */ ScrapingJobRead;
export type MonitoringStatisticsRetrieveApiArg = void;
export type OrganizationsListApiResponse = /** status 200  */ OrganizationRead[];
export type OrganizationsListApiArg = void;
export type OrganizationsCreateApiResponse = /** status 201  */ OrganizationRead;
export type OrganizationsCreateApiArg = {
  organizationRequest: OrganizationRequest;
};
export type OrganizationsRetrieveApiResponse = /** status 200  */ OrganizationRead;
export type OrganizationsRetrieveApiArg = {
  /** A UUID string identifying this organization. */
  id: string;
};
export type OrganizationsUpdateApiResponse = /** status 200  */ OrganizationRead;
export type OrganizationsUpdateApiArg = {
  /** A UUID string identifying this organization. */
  id: string;
  organizationRequest: OrganizationRequest;
};
export type OrganizationsPartialUpdateApiResponse = /** status 200  */ OrganizationRead;
export type OrganizationsPartialUpdateApiArg = {
  /** A UUID string identifying this organization. */
  id: string;
  patchedOrganizationRequest: PatchedOrganizationRequest;
};
export type OrganizationsDestroyApiResponse = unknown;
export type OrganizationsDestroyApiArg = {
  /** A UUID string identifying this organization. */
  id: string;
};
export type OrganizationsInviteMemberCreateApiResponse = /** status 200  */ OrganizationRead;
export type OrganizationsInviteMemberCreateApiArg = {
  /** A UUID string identifying this organization. */
  id: string;
  organizationRequest: OrganizationRequest;
};
export type OrganizationsStatisticsRetrieveApiResponse = /** status 200  */ OrganizationRead;
export type OrganizationsStatisticsRetrieveApiArg = {
  /** A UUID string identifying this organization. */
  id: string;
};
export type OrganizationsCreateOrganizationCreateApiResponse = /** status 200  */ OrganizationRead;
export type OrganizationsCreateOrganizationCreateApiArg = {
  organizationRequest: OrganizationRequest;
};
export type OrganizationsCurrentRetrieveApiResponse = /** status 200  */ OrganizationRead;
export type OrganizationsCurrentRetrieveApiArg = void;
export type ProxyRetrieveApiResponse = unknown;
export type ProxyRetrieveApiArg = void;
export type ProxyCreateApiResponse = unknown;
export type ProxyCreateApiArg = void;
export type SchemaDebugRetrieveApiResponse = unknown;
export type SchemaDebugRetrieveApiArg = void;
export type ScrapekingDatabaseRetrieveApiResponse = unknown;
export type ScrapekingDatabaseRetrieveApiArg = void;
export type ScrapekingDatabaseStatsRetrieveApiResponse = unknown;
export type ScrapekingDatabaseStatsRetrieveApiArg = void;
export type ScraperTemplatesRetrieveApiResponse = unknown;
export type ScraperTemplatesRetrieveApiArg = void;
export type ScrapersRetrieveApiResponse = unknown;
export type ScrapersRetrieveApiArg = void;
export type ScrapersApiResultCreateApiResponse = unknown;
export type ScrapersApiResultCreateApiArg = void;
export type ScrapersApiTaskParametersRetrieveApiResponse = unknown;
export type ScrapersApiTaskParametersRetrieveApiArg = {
  taskId: string;
};
export type ScrapersApiTaskStatusCreateApiResponse = unknown;
export type ScrapersApiTaskStatusCreateApiArg = {
  taskId: string;
};
export type ScrapersSchedulesListApiResponse = /** status 200  */ ScraperScheduleRead[];
export type ScrapersSchedulesListApiArg = {
  /** Which field to use when ordering the results. */
  ordering?: string;
};
export type ScrapersSchedulesCreateApiResponse = /** status 201  */ ScraperScheduleRead;
export type ScrapersSchedulesCreateApiArg = {
  scraperScheduleRequest: ScraperScheduleRequest;
};
export type ScrapersSchedulesRetrieveApiResponse = /** status 200  */ ScraperScheduleRead;
export type ScrapersSchedulesRetrieveApiArg = {
  id: string;
};
export type ScrapersSchedulesUpdateApiResponse = /** status 200  */ ScraperScheduleRead;
export type ScrapersSchedulesUpdateApiArg = {
  id: string;
  scraperScheduleRequest: ScraperScheduleRequest;
};
export type ScrapersSchedulesPartialUpdateApiResponse = /** status 200  */ ScraperScheduleRead;
export type ScrapersSchedulesPartialUpdateApiArg = {
  id: string;
  patchedScraperScheduleRequest: PatchedScraperScheduleRequest;
};
export type ScrapersSchedulesDestroyApiResponse = unknown;
export type ScrapersSchedulesDestroyApiArg = {
  id: string;
};
export type ScrapersSchedulesActivateCreateApiResponse = /** status 200  */ ScraperScheduleRead;
export type ScrapersSchedulesActivateCreateApiArg = {
  id: string;
  scraperScheduleRequest: ScraperScheduleRequest;
};
export type ScrapersSchedulesDeactivateCreateApiResponse = /** status 200  */ ScraperScheduleRead;
export type ScrapersSchedulesDeactivateCreateApiArg = {
  id: string;
  scraperScheduleRequest: ScraperScheduleRequest;
};
export type ScrapersSchedulesRunNowCreateApiResponse = /** status 200  */ ScraperScheduleRead;
export type ScrapersSchedulesRunNowCreateApiArg = {
  id: string;
  scraperScheduleRequest: ScraperScheduleRequest;
};
export type ScrapersTasksListApiResponse = /** status 200  */ ScraperTaskRead[];
export type ScrapersTasksListApiArg = {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
};
export type ScrapersTasksCreateApiResponse = /** status 201  */ ScraperTaskRead;
export type ScrapersTasksCreateApiArg = {
  scraperTaskRequest: ScraperTaskRequest;
};
export type ScrapersTasksRetrieveApiResponse = /** status 200  */ ScraperTaskRead;
export type ScrapersTasksRetrieveApiArg = {
  id: string;
};
export type ScrapersTasksUpdateApiResponse = /** status 200  */ ScraperTaskRead;
export type ScrapersTasksUpdateApiArg = {
  id: string;
  scraperTaskRequest: ScraperTaskRequest;
};
export type ScrapersTasksPartialUpdateApiResponse = /** status 200  */ ScraperTaskRead;
export type ScrapersTasksPartialUpdateApiArg = {
  id: string;
  patchedScraperTaskRequest: PatchedScraperTaskRequest;
};
export type ScrapersTasksDestroyApiResponse = unknown;
export type ScrapersTasksDestroyApiArg = {
  id: string;
};
export type ScrapersTasksCancelCreateApiResponse = /** status 200  */ ScraperTaskRead;
export type ScrapersTasksCancelCreateApiArg = {
  id: string;
  scraperTaskRequest: ScraperTaskRequest;
};
export type ScrapersTasksResultsRetrieveApiResponse = /** status 200  */ ScraperTaskRead;
export type ScrapersTasksResultsRetrieveApiArg = {
  id: string;
};
export type ScrapersTasksRetryCreateApiResponse = /** status 200  */ ScraperTaskRead;
export type ScrapersTasksRetryCreateApiArg = {
  id: string;
  scraperTaskRequest: ScraperTaskRequest;
};
export type ScrapersTasksStatusCheckRetrieveApiResponse = /** status 200  */ ScraperTaskRead;
export type ScrapersTasksStatusCheckRetrieveApiArg = {
  id: string;
};
export type ScrapersTasksExecuteCampaignCreateApiResponse = /** status 200  */ ScraperTaskRead;
export type ScrapersTasksExecuteCampaignCreateApiArg = {
  scraperTaskRequest: ScraperTaskRequest;
};
export type ScrapersTasksStatsRetrieveApiResponse = /** status 200  */ ScraperTaskRead;
export type ScrapersTasksStatsRetrieveApiArg = void;
export type SubscriptionPackagesRetrieveApiResponse = unknown;
export type SubscriptionPackagesRetrieveApiArg = void;
export type SubscriptionPricesRetrieveApiResponse = unknown;
export type SubscriptionPricesRetrieveApiArg = void;
export type SubscriptionSubscriptionRetrieveApiResponse = unknown;
export type SubscriptionSubscriptionRetrieveApiArg = void;
export type TemplatesRetrieveApiResponse = unknown;
export type TemplatesRetrieveApiArg = void;
export type TemplatesRetrieve2ApiResponse = unknown;
export type TemplatesRetrieve2ApiArg = {
  id: string;
};
export type TestRetrieveApiResponse = unknown;
export type TestRetrieveApiArg = void;
export type TestProxyRetrieveApiResponse = unknown;
export type TestProxyRetrieveApiArg = void;
export type UsersMeRetrieveApiResponse = /** status 200  */ UserRead;
export type UsersMeRetrieveApiArg = void;
export type UsersMePartialUpdateApiResponse = /** status 200  */ UserRead;
export type UsersMePartialUpdateApiArg = {
  patchedUserRequest: PatchedUserRequest;
};
export type TokenRefresh = {};
export type TokenRefreshRead = {
  access: string;
};
export type TokenRefreshRequest = {};
export type TokenRefreshRequestWrite = {
  refresh: string;
};
export type User = {
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: string;
  email?: string;
};
export type UserRead = {
  id: string;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: string;
  email?: string;
};
export type UserRegistrationRequest = {
  username?: string;
  email: string;
  firstname: string;
  lastname: string;
  phone: string;
};
export type UserRegistrationRequestWrite = {
  username?: string;
  email: string;
  password: string;
  firstname: string;
  lastname: string;
  phone: string;
};
export type AddTokensResponse = {
  success: boolean;
  new_balance: number;
};
export type ErrorResponse = {
  error: string;
};
export type AddTokensRequestRequest = {
  /** Target organization UUID */
  organization_id: string;
  /** Number of tokens to add */
  amount: number;
  /** Reason for adding tokens */
  reason?: string;
};
export type CheckoutResponse = {
  checkout_url: string;
  session_id: string;
};
export type CheckoutRequestRequest = {
  /** Plan key to subscribe to */
  plan: string;
};
export type EmailVerificationResult = {
  email: string;
  valid: boolean;
  reason?: string;
  score?: number;
};
export type VerifyEmailsResponse = {
  success: boolean;
  message: string;
  tokens_used?: number;
  results?: EmailVerificationResult[];
};
export type VerifyEmailsRequestLevelEnum = 'standard' | 'deep';
export type VerifyEmailsRequestRequest = {
  /** List of emails to verify (max 100) */
  emails: string[];
  /** Verification level
    
    * `standard` - standard
    * `deep` - deep */
  level?: VerifyEmailsRequestLevelEnum;
};
export type Campaign = {
  /** Campaign name */
  name: string;
  /** Campaign status (draft, active, paused, completed, failed) */
  status?: string;
  /** Campaign type ID (can be NestJS integer or Django UUID) */
  campaign_type?: string | null;
  /** Campaign configuration including scraper settings */
  config?: any;
  /** Campaign filter settings */
  filters?: any;
  /** Schedule type (once, recurring, cron) */
  schedule_type?: string | null;
  /** Schedule configuration */
  schedule_config?: any | null;
  /** Number of tokens reserved for this campaign */
  reserved_tokens?: number;
};
export type CampaignRead = {
  id: string;
  /** Campaign name */
  name: string;
  /** Campaign status (draft, active, paused, completed, failed) */
  status?: string;
  /** Campaign type ID (can be NestJS integer or Django UUID) */
  campaign_type?: string | null;
  /** Campaign configuration including scraper settings */
  config?: any;
  /** Campaign filter settings */
  filters?: any;
  /** Schedule type (once, recurring, cron) */
  schedule_type?: string | null;
  /** Schedule configuration */
  schedule_config?: any | null;
  /** Number of tokens reserved for this campaign */
  reserved_tokens?: number;
  used_tokens: number;
  total_leads: number;
  unique_leads: number;
  /** Total number of leads in this campaign */
  leads_count: number;
  /** Total number of scraping jobs for this campaign */
  jobs_count: number;
  /** Email campaign integration settings */
  email_integration: string;
  created_at: string;
  updated_at: string;
};
export type CampaignRequest = {
  /** Campaign name */
  name: string;
  /** Campaign status (draft, active, paused, completed, failed) */
  status?: string;
  /** Campaign type ID (can be NestJS integer or Django UUID) */
  campaign_type?: string | null;
  /** Campaign configuration including scraper settings */
  config?: any;
  /** Campaign filter settings */
  filters?: any;
  /** Schedule type (once, recurring, cron) */
  schedule_type?: string | null;
  /** Schedule configuration */
  schedule_config?: any | null;
  /** Number of tokens reserved for this campaign */
  reserved_tokens?: number;
};
export type CampaignRequestWrite = {
  /** Campaign name */
  name: string;
  /** Campaign status (draft, active, paused, completed, failed) */
  status?: string;
  /** Campaign type ID (can be NestJS integer or Django UUID) */
  campaign_type?: string | null;
  /** Campaign configuration including scraper settings */
  config?: any;
  /** Campaign filter settings */
  filters?: any;
  /** Schedule type (once, recurring, cron) */
  schedule_type?: string | null;
  /** Schedule configuration */
  schedule_config?: any | null;
  /** Number of tokens reserved for this campaign */
  reserved_tokens?: number;
  /** Campaign description */
  description?: string;
};
export type PatchedCampaignRequest = {
  /** Campaign name */
  name?: string;
  /** Campaign status (draft, active, paused, completed, failed) */
  status?: string;
  /** Campaign type ID (can be NestJS integer or Django UUID) */
  campaign_type?: string | null;
  /** Campaign configuration including scraper settings */
  config?: any;
  /** Campaign filter settings */
  filters?: any;
  /** Schedule type (once, recurring, cron) */
  schedule_type?: string | null;
  /** Schedule configuration */
  schedule_config?: any | null;
  /** Number of tokens reserved for this campaign */
  reserved_tokens?: number;
};
export type PatchedCampaignRequestWrite = {
  /** Campaign name */
  name?: string;
  /** Campaign status (draft, active, paused, completed, failed) */
  status?: string;
  /** Campaign type ID (can be NestJS integer or Django UUID) */
  campaign_type?: string | null;
  /** Campaign configuration including scraper settings */
  config?: any;
  /** Campaign filter settings */
  filters?: any;
  /** Schedule type (once, recurring, cron) */
  schedule_type?: string | null;
  /** Schedule configuration */
  schedule_config?: any | null;
  /** Number of tokens reserved for this campaign */
  reserved_tokens?: number;
  /** Campaign description */
  description?: string;
};
export type FlowConfigRequest = {
  enabled?: boolean;
  batch_size?: number;
  delay_minutes?: number;
  quality_threshold?: number;
  deduplication?: boolean;
};
export type EmailLinkRequest = {
  email_campaign_id: string;
  flow_config?: {
    [key: string]: any;
  };
};
export type CampaignStatus = {
  scraper: {
    [key: string]: any;
  };
  email?: {
    [key: string]: any;
  };
  integration?: {
    [key: string]: any;
  };
};
export type ProviderTypeEnum = 'OAUTH' | 'IMAP_SMTP';
export type EmailAccountResponseStatusEnum = 'ACTIVE' | 'FAILED' | 'DISABLED' | 'WARMING_UP';
export type EmailAccountResponse = {
  id: string;
  email: string;
  fromName?: string;
  providerType?: ProviderTypeEnum;
  status?: EmailAccountResponseStatusEnum;
  maxEmailPerDay?: number;
  warmupEnabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
};
export type EmailAccountCreateRequestRequest = {
  email: string;
  fromName?: string;
  smtpHost?: string;
  smtpPort?: number;
  smtpUsername?: string;
  imapHost?: string;
  imapPort?: number;
};
export type EmailAccountCreateRequestRequestWrite = {
  email: string;
  fromName?: string;
  smtpHost?: string;
  smtpPort?: number;
  smtpUsername?: string;
  smtpPassword?: string;
  imapHost?: string;
  imapPort?: number;
};
export type WarmupConfigRequest = {
  warmupDurationDays?: number;
  totalWarmupPerDay?: number;
  dailyRampUp?: number;
  replyRatePercentage?: number;
};
export type StartWarmupRequestRequest = {
  config?: WarmupConfigRequest;
};
export type TestConnectionResponse = {
  success: boolean;
  message?: string;
  imap_status?: string;
  smtp_status?: string;
};
export type MessageResponse = {
  message: string;
};
export type OAuthInitResponse = {
  authUrl: string;
  state: string;
};
export type AdminEngagedLead = {};
export type EngagementTypeEnum = 'opened' | 'replied' | 'clicked';
export type AdminEngagedLeadRead = {
  id: string;
  engagement_type: EngagementTypeEnum;
  engaged_at: string;
  email: string;
  first_name: string;
  last_name: string;
  company: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  website: string;
  source_url: string;
  industry: string;
  job_title: string;
  company_size: string;
  linkedin_url: string;
  instagram_handle: string;
  campaign_keyword: string;
  campaign_location: string;
  scraper_type: string;
  organization_id: string | null;
  organization_name: string;
  user_email: string;
  email_campaign_id: string | null;
  email_campaign_name: string;
  email_subject_line: string;
  scraped_at: string | null;
  lead_created_at: string | null;
  created_at: string;
  additional_data: any;
};
export type PaginatedAdminEngagedLeadList = {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: AdminEngagedLead[];
};
export type PaginatedAdminEngagedLeadListRead = {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: AdminEngagedLeadRead[];
};
export type CampaignAnalytics = {
  campaign_id: string;
  sent?: number;
  delivered?: number;
  opened?: number;
  clicked?: number;
  replied?: number;
  bounced?: number;
  sequence_stats?: {
    [key: string]: any;
  }[];
};
export type AnalyticsOverview = {
  sent?: number;
  delivered?: number;
  opened?: number;
  clicked?: number;
  replied?: number;
  bounced?: number;
  unsubscribed?: number;
  open_rate?: number;
  click_rate?: number;
  reply_rate?: number;
  bounce_rate?: number;
  daily_stats?: {
    [key: string]: any;
  }[];
};
export type EmailCampaign = {
  name: string;
  description?: string;
  campaign_type?: string | null;
  email_accounts?: any;
  from_name?: string;
  reply_to?: string;
  email_sequence?: any;
  schedule_type?: string | null;
  scheduled_at?: string | null;
  schedule_config?: any | null;
  timezone?: string;
  daily_limit?: number;
  send_window_start?: string | null;
  send_window_end?: string | null;
  exclude_weekends?: boolean;
  track_opens?: boolean;
  track_clicks?: boolean;
  track_replies?: boolean;
  estimated_tokens?: number;
};
export type EmailCampaignStatusEnum = 'draft' | 'scheduled' | 'running' | 'paused' | 'completed' | 'cancelled';
export type EmailCampaignStats = {};
export type EmailCampaignStatsRead = {
  total_leads: number;
  emails_sent: number;
  emails_delivered: number;
  emails_opened: number;
  emails_clicked: number;
  emails_replied: number;
  emails_bounced: number;
  emails_unsubscribed: number;
  open_rate: number;
  click_rate: number;
  reply_rate: number;
  bounce_rate: number;
  last_synced_at: string;
};
export type EmailCampaignRead = {
  id: string;
  name: string;
  description?: string;
  status: EmailCampaignStatusEnum;
  campaign_type?: string | null;
  email_accounts?: any;
  from_name?: string;
  reply_to?: string;
  email_sequence?: any;
  schedule_type?: string | null;
  scheduled_at?: string | null;
  schedule_config?: any | null;
  timezone?: string;
  daily_limit?: number;
  send_window_start?: string | null;
  send_window_end?: string | null;
  exclude_weekends?: boolean;
  track_opens?: boolean;
  track_clicks?: boolean;
  track_replies?: boolean;
  reserved_tokens: number;
  used_tokens: number;
  estimated_tokens?: number;
  created_at: string;
  updated_at: string;
  started_at: string | null;
  completed_at: string | null;
  stats: EmailCampaignStatsRead;
  leads_count: string;
  created_by_name: string;
};
export type EmailCampaignCreate = {
  name: string;
  description?: string;
  campaign_type?: string | null;
  email_accounts?: any;
  from_name?: string;
  reply_to?: string;
  email_sequence?: any;
  schedule_type?: string | null;
  scheduled_at?: string | null;
  schedule_config?: any | null;
  timezone?: string;
  daily_limit?: number;
  send_window_start?: string | null;
  send_window_end?: string | null;
  exclude_weekends?: boolean;
  track_opens?: boolean;
  track_clicks?: boolean;
  track_replies?: boolean;
  leads?: {
    [key: string]: any;
  }[];
};
export type EmailCampaignCreateRequest = {
  name: string;
  description?: string;
  campaign_type?: string | null;
  email_accounts?: any;
  from_name?: string;
  reply_to?: string;
  email_sequence?: any;
  schedule_type?: string | null;
  scheduled_at?: string | null;
  schedule_config?: any | null;
  timezone?: string;
  daily_limit?: number;
  send_window_start?: string | null;
  send_window_end?: string | null;
  exclude_weekends?: boolean;
  track_opens?: boolean;
  track_clicks?: boolean;
  track_replies?: boolean;
  leads?: {
    [key: string]: any;
  }[];
};
export type EmailCampaignRequest = {
  name: string;
  description?: string;
  campaign_type?: string | null;
  email_accounts?: any;
  from_name?: string;
  reply_to?: string;
  email_sequence?: any;
  schedule_type?: string | null;
  scheduled_at?: string | null;
  schedule_config?: any | null;
  timezone?: string;
  daily_limit?: number;
  send_window_start?: string | null;
  send_window_end?: string | null;
  exclude_weekends?: boolean;
  track_opens?: boolean;
  track_clicks?: boolean;
  track_replies?: boolean;
  estimated_tokens?: number;
};
export type PatchedEmailCampaignRequest = {
  name?: string;
  description?: string;
  campaign_type?: string | null;
  email_accounts?: any;
  from_name?: string;
  reply_to?: string;
  email_sequence?: any;
  schedule_type?: string | null;
  scheduled_at?: string | null;
  schedule_config?: any | null;
  timezone?: string;
  daily_limit?: number;
  send_window_start?: string | null;
  send_window_end?: string | null;
  exclude_weekends?: boolean;
  track_opens?: boolean;
  track_clicks?: boolean;
  track_replies?: boolean;
  estimated_tokens?: number;
};
export type CampaignCloneResponseRequest = {
  include_leads?: boolean;
};
export type EmailCampaignLeadStatusEnum =
  | 'pending'
  | 'sent'
  | 'opened'
  | 'clicked'
  | 'replied'
  | 'bounced'
  | 'unsubscribed'
  | 'failed';
export type EmailCampaignLead = {
  email: string;
  first_name?: string;
  last_name?: string;
  company?: string;
  phone?: string;
  custom_fields?: any;
  status?: EmailCampaignLeadStatusEnum;
  sent_at?: string | null;
  opened_at?: string | null;
  clicked_at?: string | null;
  replied_at?: string | null;
  source?: string;
  source_url?: string;
};
export type EmailCampaignLeadRead = {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  company?: string;
  phone?: string;
  custom_fields?: any;
  status?: EmailCampaignLeadStatusEnum;
  sent_at?: string | null;
  opened_at?: string | null;
  clicked_at?: string | null;
  replied_at?: string | null;
  source?: string;
  source_url?: string;
  created_at: string;
};
export type AddLeadsResponse = {
  message: string;
  campaign_id: string;
  total_leads: number;
};
export type EmailCampaignRefund = {
  reason: string;
  tokens_requested: number;
};
export type EmailCampaignRefundStatusEnum = 'pending' | 'approved' | 'rejected' | 'processed';
export type EmailCampaignRefundRead = {
  id: string;
  reason: string;
  tokens_requested: number;
  tokens_refunded: number;
  status: EmailCampaignRefundStatusEnum;
  requested_by_name: string;
  created_at: string;
  processed_at: string | null;
};
export type ValidationTaskResponse = {
  message: string;
  campaign_id: string;
  task_id: string;
};
export type ValidationStatus = {
  unvalidated_count: number;
  invalid_count: number;
  invalid_percentage: number;
  total_leads: number;
};
export type EmailThread = {
  id: string;
  subject: string;
  preview?: string;
  from_email: string;
  to_email: string;
  status: string;
  is_read?: boolean;
  message_count?: number;
  last_message_at: string;
  campaign_id?: string | null;
  messages?: {
    [key: string]: any;
  }[];
};
export type EmailAccountsList = {
  accounts: {
    [key: string]: any;
  }[];
};
export type EmailReplyRequest = {
  thread_id: string;
  body: string;
  html_body?: string;
};
export type MasterInbox = {
  threads?: {
    [key: string]: any;
  }[];
  total?: number;
  unread?: number;
};
export type ValidationBatch = {};
export type ValidationBatchStatusEnum = 'pending' | 'processing' | 'completed' | 'failed';
export type ValidationBatchRead = {
  id: string;
  status: ValidationBatchStatusEnum;
  total_emails: number;
  processed_emails: number;
  valid_count: number;
  invalid_count: number;
  risky_count: number;
  unknown_count: number;
  local_validated: number;
  api_validated: number;
  tokens_used: string;
  api_threshold: number;
  validation_level: string;
  created_at: string;
  started_at: string | null;
  completed_at: string | null;
  progress_percentage: string;
  valid_percentage: string;
  error_message: string;
};
export type CampaignValidationSummary = {
  campaign_id: string;
  total_leads: number;
  validated_count: number;
  unvalidated_count: number;
  valid_count: number;
  invalid_count: number;
  risky_count: number;
  invalid_percentage: number;
  is_fully_validated: boolean;
};
export type MxCheckResponse = {
  domain: string;
  has_mx: boolean;
  mx_host: string | null;
  cost: string;
};
export type EmailValidationResult = {};
export type EmailValidationResultStatusEnum = 'valid' | 'invalid' | 'risky' | 'unknown' | 'catch_all';
export type ValidationSourceEnum = 'local' | 'debounce' | 'manual';
export type EmailValidationResultRead = {
  id: string;
  email: string;
  domain: string;
  status: EmailValidationResultStatusEnum;
  syntax_valid: boolean;
  mx_valid: boolean | null;
  mx_host: string;
  is_disposable: boolean;
  is_role_based: boolean;
  is_free_provider: boolean;
  api_verified: boolean;
  api_result: string;
  api_reason: string;
  quality_score: number;
  local_score: number;
  validation_source: ValidationSourceEnum;
  validation_level: string;
  tokens_used: string;
  validated_at: string;
};
export type ValidationPricing = {
  levels: {
    [key: string]: any;
  };
  recommended: string;
  local_checks_free?: boolean;
};
export type ValidationStats = {
  total_batches: number;
  total_emails_validated: number;
  total_tokens_used: number;
  status_breakdown: {
    [key: string]: any;
  };
  average_valid_rate: number;
};
export type ValidateBatchResponse = {
  total: number;
  valid: number;
  invalid: number;
  risky: number;
  tokens_used: number;
  valid_percentage: number;
  task_id?: string;
  status?: string;
};
export type ValidateBatchRequestLevelEnum = 'simple' | 'standard' | 'premium';
export type ValidateBatchRequestRequest = {
  /** List of emails to validate (max 10,000) */
  emails: string[];
  /** Score below which to use API */
  api_threshold?: number;
  /** API verification level
    
    * `simple` - simple
    * `standard` - standard
    * `premium` - premium */
  level?: ValidateBatchRequestLevelEnum;
  /** Process in background (returns task_id) */
  async_mode?: boolean;
};
export type ValidateCampaignRequestRequest = {
  campaign_id: string;
  api_threshold?: number;
};
export type ValidateSingleResponse = {
  email: string;
  status: string;
  is_valid: boolean;
  score: number;
  cached: boolean;
  api_verified: boolean;
  mx_valid: boolean | null;
  is_disposable: boolean;
  is_role_based: boolean;
  validation_source: string;
  reason?: string;
  api_result?: string;
};
export type ValidateSingleRequestRequest = {
  email: string;
  /** Force API verification */
  use_api?: boolean;
  /** Score below which to use API (0-100) */
  api_threshold?: number;
};
export type Lead = {
  /** Campaign this lead belongs to */
  campaign?: string | null;
  /** Lead data (name, email, phone, company, etc.) */
  data?: any;
  /** Lead quality score (0-1) */
  quality_score?: number;
  /** Whether lead is available in marketplace */
  is_public?: boolean;
  /** Token price for marketplace purchase */
  price_tokens?: number;
};
export type LeadRead = {
  id: string;
  /** Campaign this lead belongs to */
  campaign?: string | null;
  /** Lead data (name, email, phone, company, etc.) */
  data?: any;
  /** Lead quality score (0-1) */
  quality_score?: number;
  /** Whether lead is available in marketplace */
  is_public?: boolean;
  /** Token price for marketplace purchase */
  price_tokens?: number;
  created_at: string;
};
export type LeadRequest = {
  /** Campaign this lead belongs to */
  campaign?: string | null;
  /** Lead data (name, email, phone, company, etc.) */
  data?: any;
  /** Lead quality score (0-1) */
  quality_score?: number;
  /** Whether lead is available in marketplace */
  is_public?: boolean;
  /** Token price for marketplace purchase */
  price_tokens?: number;
};
export type PatchedLeadRequest = {
  /** Campaign this lead belongs to */
  campaign?: string | null;
  /** Lead data (name, email, phone, company, etc.) */
  data?: any;
  /** Lead quality score (0-1) */
  quality_score?: number;
  /** Whether lead is available in marketplace */
  is_public?: boolean;
  /** Token price for marketplace purchase */
  price_tokens?: number;
};
export type ScrapingJob = {
  campaign?: string | null;
  /** Job status (pending, running, completed, failed, cancelled) */
  status?: string;
  /** Number of leads collected */
  leads_count?: number;
  /** Tokens consumed by this job */
  tokens_used?: string;
};
export type ScrapingJobRead = {
  id: string;
  campaign?: string | null;
  /** Name of the associated campaign */
  campaign_name: string;
  /** Job status (pending, running, completed, failed, cancelled) */
  status?: string;
  /** Number of leads collected */
  leads_count?: number;
  /** Tokens consumed by this job */
  tokens_used?: string;
  created_at: string;
  updated_at: string;
};
export type ScrapingJobRequest = {
  campaign?: string | null;
  /** Job status (pending, running, completed, failed, cancelled) */
  status?: string;
  /** Number of leads collected */
  leads_count?: number;
  /** Tokens consumed by this job */
  tokens_used?: string;
};
export type Organization = {
  /** Organization display name */
  name: string;
  /** URL-friendly organization identifier */
  slug?: string | null;
};
export type OrganizationRead = {
  id: string;
  /** Organization display name */
  name: string;
  /** URL-friendly organization identifier */
  slug?: string | null;
  /** Number of users in the organization */
  user_count: number;
  created_at: string;
  updated_at: string;
};
export type OrganizationRequest = {
  /** Organization display name */
  name: string;
  /** URL-friendly organization identifier */
  slug?: string | null;
};
export type PatchedOrganizationRequest = {
  /** Organization display name */
  name?: string;
  /** URL-friendly organization identifier */
  slug?: string | null;
};
export type FrequencyEnum = 'once' | 'daily' | 'weekly' | 'monthly' | 'custom';
export type ScraperSchedule = {
  campaign: string;
  frequency?: FrequencyEnum;
  /** Cron expression for custom frequency */
  cron_expression?: string;
  start_date?: string;
  end_date?: string | null;
  time_of_day?: string;
  timezone_name?: string;
  days_of_week?: any;
  day_of_month?: number | null;
  is_active?: boolean;
};
export type ScraperScheduleRead = {
  id: number;
  campaign: string;
  campaign_name: string;
  frequency?: FrequencyEnum;
  /** Cron expression for custom frequency */
  cron_expression?: string;
  start_date?: string;
  end_date?: string | null;
  time_of_day?: string;
  timezone_name?: string;
  days_of_week?: any;
  day_of_month?: number | null;
  is_active?: boolean;
  last_run: string | null;
  next_run: string | null;
  next_run_formatted: string;
  created_at: string;
  updated_at: string;
};
export type ScraperScheduleRequest = {
  campaign: string;
  frequency?: FrequencyEnum;
  /** Cron expression for custom frequency */
  cron_expression?: string;
  start_date?: string;
  end_date?: string | null;
  time_of_day?: string;
  timezone_name?: string;
  days_of_week?: any;
  day_of_month?: number | null;
  is_active?: boolean;
};
export type PatchedScraperScheduleRequest = {
  campaign?: string;
  frequency?: FrequencyEnum;
  /** Cron expression for custom frequency */
  cron_expression?: string;
  start_date?: string;
  end_date?: string | null;
  time_of_day?: string;
  timezone_name?: string;
  days_of_week?: any;
  day_of_month?: number | null;
  is_active?: boolean;
};
export type ScraperTypeEnum =
  | 'amazon'
  | 'linkedin'
  | 'indeed'
  | 'google'
  | 'zillow'
  | 'realtor'
  | 'yelp'
  | 'yellowpages';
export type ExecutionModeEnum = 'local' | 'aws_batch' | 'celery';
export type ScraperTask = {
  campaign: string;
  user: string;
  organization?: string | null;
  scraper_type: ScraperTypeEnum;
  execution_mode?: ExecutionModeEnum;
  keyword: string;
  location?: string;
  leads_count?: number;
  parameters?: any;
  max_retries?: number;
};
export type ScraperTaskStatusEnum = 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';
export type ScraperTaskRead = {
  id: string;
  campaign: string;
  campaign_name: string;
  user: string;
  user_email: string;
  organization?: string | null;
  scraper_type: ScraperTypeEnum;
  execution_mode?: ExecutionModeEnum;
  keyword: string;
  location?: string;
  leads_count?: number;
  parameters?: any;
  batch_job_id: string;
  batch_job_name: string;
  celery_task_id: string;
  status: ScraperTaskStatusEnum;
  started_at: string | null;
  completed_at: string | null;
  error_message: string;
  retry_count: number;
  max_retries?: number;
  results_count: number;
  s3_path: string;
  sqs_messages_processed: number;
  execution_time_seconds: number | null;
  execution_time: string;
  memory_used_mb: number | null;
  created_at: string;
  updated_at: string;
};
export type ScraperTaskRequest = {
  campaign: string;
  user: string;
  organization?: string | null;
  scraper_type: ScraperTypeEnum;
  execution_mode?: ExecutionModeEnum;
  keyword: string;
  location?: string;
  leads_count?: number;
  parameters?: any;
  max_retries?: number;
};
export type PatchedScraperTaskRequest = {
  campaign?: string;
  user?: string;
  organization?: string | null;
  scraper_type?: ScraperTypeEnum;
  execution_mode?: ExecutionModeEnum;
  keyword?: string;
  location?: string;
  leads_count?: number;
  parameters?: any;
  max_retries?: number;
};
export type PatchedUserRequest = {
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username?: string;
  email?: string;
};
export const {
  useGetApiApiDocsJsonQuery,
  useAuthChangePasswordCreateMutation,
  useAuthConfirmEmailCreateMutation,
  useAuthForgotPasswordCreateMutation,
  useAuthIsVerifiedRetrieveQuery,
  useAuthLoginCreateMutation,
  useAuthRefreshCreateMutation,
  useAuthRegisterCreateMutation,
  useAuthResendCodeCreateMutation,
  useAuthResetPasswordCreateMutation,
  useAuthVerifyEmailRetrieveQuery,
  useBillingAddTokensCreateMutation,
  useBillingAddTokensCreate2Mutation,
  useBillingBalanceRetrieveQuery,
  useBillingCheckoutCreateMutation,
  useBillingDebouncePricingRetrieveQuery,
  useBillingPlansRetrieveQuery,
  useBillingSubscriptionCancelCreateMutation,
  useBillingTokenCostsRetrieveQuery,
  useBillingTransactionsRetrieveQuery,
  useBillingVerifyEmailsCreateMutation,
  useBillingWebhookStripeCreateMutation,
  useCampaignFiltersRetrieveQuery,
  useCampaignSourcesRetrieveQuery,
  useCampaignTypesRetrieveQuery,
  useCampaignTypesProperRetrieveQuery,
  useCampaignsListQuery,
  useCampaignsCreateMutation,
  useCampaignsRetrieveQuery,
  useCampaignsUpdateMutation,
  useCampaignsPartialUpdateMutation,
  useCampaignsDestroyMutation,
  useCampaignsFlowConfigCreateMutation,
  useCampaignsLeadsRetrieveQuery,
  useCampaignsLinkEmailCreateMutation,
  useCampaignsPublishLeadsCreateMutation,
  useCampaignsStartCreateMutation,
  useCampaignsStatusRetrieveQuery,
  useCampaignsStopCreateMutation,
  useCampaignsTypesRetrieveQuery,
  useEmailCampaignsAccountsListQuery,
  useEmailCampaignsAccountsCreateMutation,
  useEmailCampaignsAccountsRetrieveQuery,
  useEmailCampaignsAccountsUpdateMutation,
  useEmailCampaignsAccountsDestroyMutation,
  useEmailCampaignsAccountsPauseWarmupCreateMutation,
  useEmailCampaignsAccountsStartWarmupCreateMutation,
  useEmailCampaignsAccountsTestCreateMutation,
  useEmailCampaignsAccountsWarmupStatusRetrieveQuery,
  useEmailCampaignsAccountsImapSmtpCreateMutation,
  useEmailCampaignsAccountsOauthGmailCallbackCreateMutation,
  useEmailCampaignsAccountsOauthGmailInitCreateMutation,
  useEmailCampaignsAccountsOauthOutlookCallbackCreateMutation,
  useEmailCampaignsAccountsOauthOutlookInitCreateMutation,
  useEmailCampaignsAdminEngagedLeadsListQuery,
  useEmailCampaignsAdminEngagedLeadsRetrieveQuery,
  useEmailCampaignsAdminEngagedLeadsAnalyticsRetrieveQuery,
  useEmailCampaignsAdminEngagedLeadsExportCsvRetrieveQuery,
  useEmailCampaignsAdminEngagedLeadsExportExcelRetrieveQuery,
  useEmailCampaignsAdminEngagedLeadsSummaryRetrieveQuery,
  useEmailCampaignsEmailAnalyticsCampaignRetrieveQuery,
  useEmailCampaignsEmailAnalyticsOverviewRetrieveQuery,
  useEmailCampaignsEmailCampaignsListQuery,
  useEmailCampaignsEmailCampaignsCreateMutation,
  useEmailCampaignsEmailCampaignsRetrieveQuery,
  useEmailCampaignsEmailCampaignsUpdateMutation,
  useEmailCampaignsEmailCampaignsPartialUpdateMutation,
  useEmailCampaignsEmailCampaignsDestroyMutation,
  useEmailCampaignsEmailCampaignsCancelCreateMutation,
  useEmailCampaignsEmailCampaignsCloneCreateMutation,
  useEmailCampaignsEmailCampaignsLeadsListQuery,
  useEmailCampaignsEmailCampaignsLeadsCreateMutation,
  useEmailCampaignsEmailCampaignsPauseCreateMutation,
  useEmailCampaignsEmailCampaignsRequestRefundCreateMutation,
  useEmailCampaignsEmailCampaignsResumeCreateMutation,
  useEmailCampaignsEmailCampaignsStartCreateMutation,
  useEmailCampaignsEmailCampaignsStatsRetrieveQuery,
  useEmailCampaignsEmailCampaignsValidateEmailsCreateMutation,
  useEmailCampaignsEmailCampaignsValidationStatusRetrieveQuery,
  useEmailCampaignsMasterInboxThreadRetrieveQuery,
  useEmailCampaignsMasterInboxAccountsRetrieveQuery,
  useEmailCampaignsMasterInboxMarkReadCreateMutation,
  useEmailCampaignsMasterInboxReplyCreateMutation,
  useEmailCampaignsMasterInboxThreadsRetrieveQuery,
  useEmailCampaignsValidationBatchesListQuery,
  useEmailCampaignsValidationCampaignStatusRetrieveQuery,
  useEmailCampaignsValidationCheckMxRetrieveQuery,
  useEmailCampaignsValidationLookupRetrieveQuery,
  useEmailCampaignsValidationPricingRetrieveQuery,
  useEmailCampaignsValidationStatsRetrieveQuery,
  useEmailCampaignsValidationValidateBatchCreateMutation,
  useEmailCampaignsValidationValidateCampaignCreateMutation,
  useEmailCampaignsValidationValidateSingleCreateMutation,
  useEnrichmentBatchCreateMutation,
  useEnrichmentEnhancedCreateMutation,
  useEnrichmentEnhancedBatchCreateMutation,
  useEnrichmentEnhancedStatsRetrieveQuery,
  useEnrichmentFindDomainCreateMutation,
  useEnrichmentJobCreateMutation,
  useEnrichmentJobRetrieveQuery,
  useEnrichmentLeadCreateMutation,
  useEnrichmentSmartCreateMutation,
  useEnrichmentSmartBatchCreateMutation,
  useEnrichmentStatsRetrieveQuery,
  useEnrichmentVerifyEmailCreateMutation,
  useHealthRetrieveQuery,
  useJobsRetrieveQuery,
  useJobsRetrieve2Query,
  useLeadsListQuery,
  useLeadsCreateMutation,
  useLeadsRetrieveQuery,
  useLeadsUpdateMutation,
  useLeadsPartialUpdateMutation,
  useLeadsDestroyMutation,
  useLeadsBulkCreateCreateMutation,
  useLeadsDatabaseRetrieveQuery,
  useLeadsDatabaseStatsRetrieveQuery,
  useLeadsFilterOptionsRetrieveQuery,
  useLeadsMineRetrieveQuery,
  useLegacyCampaignTypesRetrieveQuery,
  useLegacyScrapersRetrieveQuery,
  useMarketplaceRetrieveQuery,
  useMarketplacePurchaseCreateMutation,
  useMarketplaceAnalyticsRetrieveQuery,
  useMarketplacePurchasedRetrieveQuery,
  useMonitoringListQuery,
  useMonitoringRetrieveQuery,
  useMonitoringCancelCreateMutation,
  useMonitoringStatisticsRetrieveQuery,
  useOrganizationsListQuery,
  useOrganizationsCreateMutation,
  useOrganizationsRetrieveQuery,
  useOrganizationsUpdateMutation,
  useOrganizationsPartialUpdateMutation,
  useOrganizationsDestroyMutation,
  useOrganizationsInviteMemberCreateMutation,
  useOrganizationsStatisticsRetrieveQuery,
  useOrganizationsCreateOrganizationCreateMutation,
  useOrganizationsCurrentRetrieveQuery,
  useProxyRetrieveQuery,
  useProxyCreateMutation,
  useSchemaDebugRetrieveQuery,
  useScrapekingDatabaseRetrieveQuery,
  useScrapekingDatabaseStatsRetrieveQuery,
  useScraperTemplatesRetrieveQuery,
  useScrapersRetrieveQuery,
  useScrapersApiResultCreateMutation,
  useScrapersApiTaskParametersRetrieveQuery,
  useScrapersApiTaskStatusCreateMutation,
  useScrapersSchedulesListQuery,
  useScrapersSchedulesCreateMutation,
  useScrapersSchedulesRetrieveQuery,
  useScrapersSchedulesUpdateMutation,
  useScrapersSchedulesPartialUpdateMutation,
  useScrapersSchedulesDestroyMutation,
  useScrapersSchedulesActivateCreateMutation,
  useScrapersSchedulesDeactivateCreateMutation,
  useScrapersSchedulesRunNowCreateMutation,
  useScrapersTasksListQuery,
  useScrapersTasksCreateMutation,
  useScrapersTasksRetrieveQuery,
  useScrapersTasksUpdateMutation,
  useScrapersTasksPartialUpdateMutation,
  useScrapersTasksDestroyMutation,
  useScrapersTasksCancelCreateMutation,
  useScrapersTasksResultsRetrieveQuery,
  useScrapersTasksRetryCreateMutation,
  useScrapersTasksStatusCheckRetrieveQuery,
  useScrapersTasksExecuteCampaignCreateMutation,
  useScrapersTasksStatsRetrieveQuery,
  useSubscriptionPackagesRetrieveQuery,
  useSubscriptionPricesRetrieveQuery,
  useSubscriptionSubscriptionRetrieveQuery,
  useTemplatesRetrieveQuery,
  useTemplatesRetrieve2Query,
  useTestRetrieveQuery,
  useTestProxyRetrieveQuery,
  useUsersMeRetrieveQuery,
  useUsersMePartialUpdateMutation,
} = injectedRtkApi;
